<script>
    import Trix from './Trix.vue';
    import draggable from 'vuedraggable';
    //import Clipboard from 'v-clipboard';
    import { Chrome } from 'vue-color'
    import { mixin as clickaway } from 'vue-clickaway';
    import VueDraggableResizable from 'vue-draggable-resizable';
    import Signature from '../mixins/Signature';
    // Vue.use(Clipboard);
    // Vue.use(draggable);
    export default {
        props: {
            load_signatureid: {
                type: Number,
                default: null,
            },
            load_user_id: {
                type: Number,
                default: null,
            },
            load_organization_id: {
                type: Number,
                default: null,
            },
            load_user_email: {
                type: String,
                default: null,
            },
            load_signature_name: {
                type: String,
                default: null,
            },
            load_signature_title: {
                type: String,
                default: null,
            },
            load_signature_slug: {
                type: String,
                default: null,
            },
            load_signature_access_code: {
                type: String,
                default: null,
            },
            load_purchased: {
                type: Boolean,
                default: false,
            },
            before_free_limit: {
                type: Boolean,
                default: false,
            },
            disable_signature_tracks: {
                type: Boolean,
                default: false,
            },
            load_aws_url: {
                type: String,
                default: null,
            },
            load_env: {
                type: String,
                default: 'production',
            }
        },
        components: {
            draggable,
            'chrome-picker': Chrome,
            VueDraggableResizable,
            Trix,
        },
        mixins: [clickaway, Signature],
        data: function () {
            return {
                view: 'designer',
                signatureid: null,
                user_id: null,
                user: null,
                single_signature: true,
                organization_id: null,
                organization: null,
                purchased: false,
                signature_name: null,
                signature_title: null,
                signature_slug: null,
                signature_access_code: null,
                starting_signature_slug: null,
                signature_slug_timeout: null,
                signature_slug_available: null,
                published: null, 
                loaded: false,
                statsEmail: null,
                statsEmailValid: true,

                previewActive: false,
                designscreen: 'styles',
                lastscreen: null,
                currentfield: null,
                currentline: null,
                currentcolumn: null,
                currentcolumntable: null,
                colorPickerOpen: false, 
                colorPickerType: null,
                colorPickerProperty: null, 
                colorTimeout: null,
                signatureHeightClass: 'short',

                dragging: false,

                hoverField: null,
                signatureHover: false,

                accountEmail: '',
                accountPassword: '',
                accountPasswordConfirm: '',
                accountEmailConsent: false,
                createAccountAndSaveErrors: null,
                purchaseMode: null,
                templatePurchaseDesired: null,

                purchaseName: '',
                purchaseOrganizationName: '',
                purchasePassword: '',
                purchaseConfirmPassword: '',
                purchasePeriod: 'Monthly',
                purchaseErrors: null,

                mobileDismiss: false,

                validToCopy: true,
                signatureDistributionMode: null,

                token: null,
                error: null,
                stripe: undefined,
                elements: undefined,
                card: undefined,
                style: {
                    base: {
                        color: '#FFFFFF',
                        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                        fontSmoothing: 'antialiased',
                        fontSize: '16px',
                        '::placeholder': {
                            color: '#999999'
                        }
                    },
                    invalid: {
                        color: '#fa755a',
                        iconColor: '#fa755a'
                    }
                },

                showStartModal: false,
                showAddFieldModal: false, 
                addFieldModalActive: 'Personal',
                addFieldAllowColumns: true,
                addFieldAllowBox: true,
                addFieldNewLine: false,
                lineToAddFieldTo: null,
                showTemplateModal: true,
                timeToUpgradeModal: false,
                featureModal: false,
                featureModalType: 'icon',
                featureModalTypeSpecific: null,
                tutorialModal: false,
                signatureSaveModal: false,
                showCreateAccountModal: false, 
                showPricingModal: false,
                showUpgradeModal: false,
                showIconModal: false,
                iconModalSearch: '',
                showHelpModal: false,
                signatureCopiedModal: false,
                showPurchaseModal: false,
                signatureEdited: false,
                showSendEmailModal: false,
                sendSignatureEmail: '',
                sendSignatureReplyEmail: '',
                sendSignatureEmailEdit: false,
                sendEmailError: null,
                unique_fids: [],

                chosenPlan: null,
                //copyCodeMode: false,
                signature: null,
                signaturePastVersions: [],
                signatureFutureVersions: [],
                recentlySaved: false,
                signatureBackup: null,
                available_fields: null,
                available_buttons: null,
                icons: null,
                iconSet: 'fa',
                iconStyle: 'solid',
                iconModalInsert: null,
                available_templates: null,
                fields_used: 0,
                images_used: 0,
                field_types: [
                    'Personal',
                    'Company',
                    'Contact',
                    'Social',
                    'Button',
                    'Generic'
                ],
                default_line: {"fields":[],"fontFamily":"sigdefault","fontWeight":"sigdefault","fontSize":"","textAlign":"left","fontColor":"","lineHeight":"sigdefault","marginTop":"0","marginRight":"0","marginBottom":"0","marginLeft":"0","borderTop":"0","borderTopColor":"","borderRight":"0","borderRightColor":"","borderBottom":"0","borderBottomColor":"","borderLeft":"0","borderLeftColor":"","hover":false},
                default_column: {"hover":false,"lines":[{"hover":false,"fields":[{"link": "", "slug": "text", "type": "text", "after": "disabled", "hover": false, "label": "Text", "notes": "", "valid": true, "value": "", "before": "disabled", "display": true, "category": "Generic", "editable": "value", "fontSize": "", "required": true, "afterIcon": "", "afterText": "", "fontColor": "", "fontStyle": "linedefault", "marginTop": 0, "afterColor": "", "beforeIcon": "", "beforeText": "", "fontFamily": "linedefault", "fontWeight": "linedefault", "marginLeft": 0, "beforeColor": "", "marginRight": 0, "placeholder": "Text", "afterIconSet": "", "marginBottom": 0, "afterIconSize": "16", "beforeIconSet": "", "letterSpacing": "normal", "textTransform": "normal", "afterIconStyle": "", "beforeIconSize": "16", "textDecoration": "linedefault", "afterTextWeight": "fielddefault", "beforeIconStyle": "", "beforeTextWeight": "fielddefault", "afterIconColorType": "gray", "afterIconOrigWidth": "", "afterIconOrigHeight": "", "beforeIconColorType": "gray", "beforeIconOrigWidth": "", "beforeIconOrigHeight": ""}],"fontSize":"","borderTop":"0","fontColor":"","fontStyle":"sigdefault","marginTop":"0","textAlign":"left","borderLeft":"0","fontFamily":"sigdefault","fontWeight":"sigdefault","lineHeight":"sigdefault","marginLeft":"0","borderRight":"0","marginRight":"0","borderBottom":"0","borderLocked":false,"marginBottom":"0","marginLocked":false,"borderTopColor":"","textDecoration":"sigdefault","borderLeftColor":"","borderRightColor":"","borderBottomColor":"","borderBottomColorPicker":false}],"width":50,"active":true,"borderTop":0,"borderLeft":0,"paddingTop":"0","borderColor":"","borderRight":0,"paddingLeft":0,"borderBottom":0,"borderLocked":false,"paddingRight":0,"paddingBottom":"0","verticalAlign":"middle"},
                //fieldKeys: ["name", "title", "companyName", "address1", "address2", "city", "state", "zip", "phone_main", "phone_direct", "phone_mobile", "phone_fax", "website"]
            }
        },
        mounted: function() {
            //console.log(JSON.stringify(this.signature));
            if (this.load_signatureid) {
                this.signatureid = this.load_signatureid;
                this.showStartModal = false;
                this.showTemplateModal = false;
                this.recentlySaved = true;
            }
            if (this.load_user_id) {
                this.user_id = this.load_user_id;
            }
            if (this.load_organization_id) {
                this.organization_id = this.load_organization_id;
            }
            if (this.load_user_email) {
                this.accountEmail = this.load_user_email;
                this.sendSignatureEmail = this.load_user_email;
            }
            if (this.load_signature_name) {
                this.signature_name = this.load_signature_name;
            } else {
                this.signature_name = "My Signature";
            }
            if (this.load_signature_title) {
                this.signature_title = this.load_signature_title;
            } else {
                this.signature_title = "Email Signature";
            }
            if (this.load_signature_slug) {
                this.signature_slug = this.load_signature_slug;
                this.starting_signature_slug = this.load_signature_slug;
            }
            if (this.load_signature_access_code) {
                this.signature_access_code = this.load_signature_access_code;
            }
            if (this.load_purchased) {
                this.purchased = this.load_purchased;
            }
            var self = this;
            var urlToGet = '';
            if (self.signatureid) {
                urlToGet = '/generator/data/' + self.signatureid;
            } else {
                urlToGet = '/generator/data/';
            }
            axios.get(urlToGet)
            .then(function(response) {
                //console.log(response.data);
                self.signature = response.data.signature;
                self.available_fields = response.data.available_fields;
                self.available_templates = response.data.available_templates;
                self.available_buttons = response.data.available_buttons;
                self.icons = response.data.icons;
                self.signatureEdited = response.data.signature_edited;
                if (response.data.published && response.data.published == true) {
                    self.published = true;
                }
                //console.log(response.data);
                //console.log(response.data.single_signature);
                if (response.data.hasOwnProperty('single_signature') && response.data.single_signature === false) {
                    //console.log("this happened");
                    self.single_signature = false;
                }
                self.user = response.data.user;
                self.organization = response.data.organization;
                self.checkForOrgSupportedEmailApps();
                if (self.signature_title == "Email Signature" && self.organization && self.organization.name) {
                    self.signature_title = self.organization.name + " Email Signature";
                }
                if (self.signatureid == null && self.organization && self.organization.signature_count >= self.organization.templates) {
                    self.timeToUpgradeModal = true;
                }
                //if (response.data.)
                self.loaded = true;
                self.checkForEditableRequiredEmail('truefalse');
                self.deselectLinesOnStart();
                self.countUsage();
                self.recalculateSignatureHeightClass();
                self.unique_fids = self.getFieldIds();
            }.bind(this)).catch(function(data) {
                console.log('error');
            });
        },
        computed: {
            //v-clipboard:copy="this.$refs"
            // signature: function() {
            //     return '<div style="text-align: left; color: #666666; font-family: \'HelveticaNeue - Light\', \'Helvetica Neue Light\', \'Helvetica Neue\', Helvetica, Arial, \'Lucida Grande\', sans-serif; font-size: 10pt; line-height:16pt"><div>' + this.name + '</div><div>' + this.title + '</div><div>' + this.phone_mobile + '</div><div><a href="#">jessesutherland.com</a></div></div>';
            // }
            videoUrl: function() {
                if (this.loaded) {
                    if (this.single_signature) {
                        return 'https://www.youtube.com/embed/8JtizCJW96c?autoplay=1&modestbranding=1&rel=0';
                    } else {
                        return 'https://www.youtube.com/embed/z_RaSsmERso?autoplay=1&modestbranding=1&rel=0';
                    }
                }
            },
            currentlinePlusOne: function() {
                return this.currentline + 1;
            },
            // fieldKeys: function() {
            //     // var fieldKeys = [];
            //     // this.fields.forEach(function (field, key) {
            //     //     fieldKeys.push(key);
            //     // });
            //     return Object.keys(this.signature.fields);
            // },
            signatureLink: function() {
                if (this.load_env == 'development') {
                    return "http://" + this.signature_slug + ".signatureemail.lndo.site";
                } else {
                    return "https://" + this.signature_slug + ".signature.email";
                }
            },
            currentScreenIsStyles: function() {
                if (this.designscreen == 'styles') {
                    return true;
                } else {
                    return false;
                }
            },
            menuActive: function() {
                if (this.designscreen == 'menu') {
                    return true;
                } else {
                    return false;
                }
            },
            uniqueButtonsTotal: function() {
                var totalButtons = 0;
                if (this.available_buttons) {
                    // this.available_buttons.forEach(function ( button ) {
                    //     totalButtons = totalButtons + button.length;
                    // }, totalButtons);
                    for (const button in this.available_buttons) {
                        if (this.available_buttons.hasOwnProperty(button)) {
                            totalButtons = totalButtons + button.length;
                        }
                    }
                }
                totalButtons = Math.floor(totalButtons / 10) * 10;
                return totalButtons;
            },
            filteredIcons: function() {
                var filtered_icons = this.icons;
                filtered_icons = filtered_icons.filter(function(icon) {
                    if (icon.set == this.iconSet && icon.style.indexOf(this.iconStyle) !== -1) {
                        return true;
                    } else {
                        return false;
                    }
                }, this, filtered_icons);
                if (this.iconModalSearch) {
                    var queryTerms = this.iconModalSearch.split(' ');
                    var filtered_icons_with_search = filtered_icons.filter(function(icon) {
                        if (icon.search) {
                            var found = true;
                            for(var i = 0; i < queryTerms.length; i++) {
                                if (icon.search.indexOf(queryTerms[i].toLowerCase()) !== -1) {
                                    //found = true;
                                } else {
                                    found = false;
                                }
                            }
                            return found;
                        } else {
                            return false;
                        }
                    }, this, filtered_icons, queryTerms);
                    filtered_icons = filtered_icons_with_search;
                }
                return filtered_icons;
            }
        },
        created() {
            window.addEventListener('keydown', this.listenForKeyCommands);
            window.addEventListener('beforeunload', this.beforeLeave);
        },
        destroyed() {
            window.removeEventListener('keydown', this.listenForKeyCommands);
        },
        methods: {
            minWidth: function() {
                var minWidth = 100;
                this.signature.lines.forEach(function ( line ) {
                    if (line.type == 'box') {
                        if (line.width > minWidth) {
                            minWidth = line.width;
                        }
                    } else if (line.type == 'columns') {
                        if (line.width > minWidth) {
                            minWidth = line.width;
                        }
                    }
                }, minWidth);
                return minWidth;
            },
            countUsage: function() {
                var fields_used = 0;
                var images_used = 0;
                var self = this;
                //Loop through old signature, save some values
                self.signature.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield, fieldindex ) {
                                fields_used++;
                                if (thefield.type == 'image') {
                                    images_used++;
                                }
                            });
                        }, line, fields_used, images_used, self);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            fields_used++;
                                            if (thefield.type == 'image') {
                                                images_used++;
                                            }
                                        }, line, fields_used, images_used, self);
                                    }, line, fields_used, images_used, self);
                                } else {
                                    columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        fields_used++;
                                        if (thefield.type == 'image') {
                                            images_used++;
                                        }
                                    }, line, fields_used, images_used, self);
                                }
                            }, line, fields_used, images_used, self);
                        }, line, fields_used, images_used, self);
                    } else {
                        line.fields.forEach(function ( thefield, fieldindex ) {
                            fields_used++;
                            if (thefield.type == 'image') {
                                images_used++;
                            }
                        }, fields_used, images_used, self);
                    }
                }, fields_used, images_used, self);
                self.fields_used = fields_used;
                self.images_used = images_used;
            },
            deselectLinesOnStart: function() {
                var self = this;
                self.signature.lines.forEach(function ( line ) {
                    line.active = false;
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            line.active = false;
                            // boxline.fields.forEach(function ( thefield, fieldindex ) {
                                
                            // });
                        }, line);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.active = false;
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        // boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            
                                        // }, line);
                                    }, line);
                                } else {
                                    // columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        
                                    // }, line);
                                }
                            }, line);
                        }, line);
                    } else {
                        // line.fields.forEach(function ( thefield, fieldindex ) {
                            
                        // });
                    }
                });
            },
            updateTrixContent: function(event,type) {
                var content = event;
                var content_end = content.slice(-15);
                if (content_end == "<div><br></div>") {
                    content = content.slice(0, -15);
                }
                var divcount = (content.match(/<div>/g) || []).length;
                var content_start_2 = content.slice(0,5);
                var content_end_2 = content.slice(-6);
                if (divcount === 1 && content_start_2 == "<div>" && content_end_2 == "</div>") {
                    content = content.slice(5, -6);
                }
                this.currentfield.value = content;
            },
            addChoice: function() {
                var newLength = this.currentfield.choices.push({"link": "", "label": "", "value": "", "collapsed": false});
                var newFieldIndex = -1;
                this.currentfield.choices.forEach(function ( choice, index ) {
                    if (choice.collapsed === false) {
                        newFieldIndex++;
                    }
                }, newFieldIndex);
                this.$nextTick(function () {
                    this.$refs.choiceFields[newFieldIndex].focus();
                });
            },
            addImageChoice: function() {
                var newLength = this.currentfield.choices.push({"id": "", "url": "", "link": "", "value": "", "width": "300", "cropping": "none", "parentId": null, "collapsed": false, "selfHosted": false, "choicelabel": "", "originalUrl": "", "placeholder": "", "cropParentId": null, "originalWidth": 0, "selfHostedUrl": "", "originalHeight": 0, "selfHostedWidth": "", "placeholderImage": false, "selfHostedHeight": "", "placeholderImageUrl": ""});
                var newFieldIndex = -1;
                this.currentfield.choices.forEach(function ( choice, index ) {
                    if (choice.collapsed === false) {
                        newFieldIndex++;
                    }
                }, newFieldIndex);
                this.$nextTick(function () {
                    this.$refs.choiceFields[newFieldIndex].focus();
                });
            },
            removeChoice: function(index) {
                if (this.currentfield.choices.length == 1) {
                    alert("You cannot remove the last choice.");
                    return;
                } else {
                    var confirmation = confirm("Are you sure you want to delete this choice?");
                    if (confirmation == true) {
                        this.currentfield.choices.splice(index,1);
                    }
                }
            },
            beforeLeave(e) {
                if (!this.recentlySaved) {
                    return e.returnValue = 'Changes you made may not be saved.';
                }
            },
            activeValue: function(expectedValue, actualValue) {
                if (expectedValue === actualValue) {
                    return true;
                } else {
                    return false;
                }
            },
            notActiveSeparator(actualValue) {
                var separators = ['•', '|', '-', ':'];
                if(separators.indexOf(actualValue) !== -1) {
                    return false;
                } else {
                    return true;
                }
            },
            availableButtons: function(slug) {
                if (this.available_buttons.hasOwnProperty(slug)) {
                    return this.available_buttons[slug];
                } else {
                    return null;
                }
            },
            isCurrentButton: function(button, currentfield) {
                if (button.key === currentfield.chosen) {
                    return true;
                } else {
                    return false;
                }
            },
            buttonPlaceholder: function() {
                if (this.currentfield.slug == 'emailbutton') {
                    return 'you@company.com';
                } else {
                    return 'https://';
                }
            },
            availableSizes: function(currentfield) {
                if (this.available_buttons.hasOwnProperty(currentfield.slug)) {
                    var foundButton = null;
                    this.available_buttons[currentfield.slug].forEach(function ( button ) {
                        if (button.key === currentfield.chosen) {
                            foundButton = button;
                        }
                    }, currentfield, foundButton);
                    if (foundButton) {
                        return foundButton.sizes;
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            },
            sizeIsAvailable: function(currentfield, size) {
                if (this.available_buttons.hasOwnProperty(currentfield.slug)) {
                    var foundButton = null;
                    this.available_buttons[currentfield.slug].forEach(function ( button ) {
                        if (button.key === currentfield.chosen) {
                            foundButton = button;
                        }
                    }, currentfield, foundButton);
                    if (foundButton) {
                        var found = false;
                        foundButton.sizes.forEach(function ( sizeobject ) {
                            if (sizeobject.key === size) {
                                found = true;
                            }
                        }, currentfield, size, found);
                        return found;
                    } else {
                        return false;
                    }
                } else {
                    return false;
                }
            },
            convertToPlaceholder: function(field) {
                field.placeholderImage = true;
                field.placeholderImageUrl = field.url;
                field.id = null;
                field.parentId = null;
                field.cropParentId = null;
                field.originalUrl = null;
                // field.originalWidth = 0;
                // field.originalHeight = 0;
            },
            imageEditableChange: function() {
                //THIS WHOLE FUNCTION CAN BE REMOVED IN THE FUTURE
                // if (this.currentfield.type == 'image' && (this.currentfield.editable == 'no' || this.currentfield.editable == 'link' || this.currentfield.editable == 'displaytoggle') && this.currentfield.placeholderImage) {
                //     this.currentfield.placeholderImage = false;
                //     this.currentfield.placeholderImageUrl = '';
                // }
            },
            buttonImageUrl: function(button, currentfield) {
                var bgColor = '666666';
                if (currentfield.backgroundColorType === 'default') {
                    bgColor = currentfield.defaultBackground;
                } if (currentfield.backgroundColorType == 'black') {
                    bgColor = '#000000';
                } else if (currentfield.backgroundColorType == 'gray') {
                    bgColor = '#666666';
                } else if (currentfield.backgroundColorType == 'linkcolor') {
                    bgColor = this.signature.settings.linkColor;
                } else if (currentfield.backgroundColorType == 'other' && currentfield.backgroundColor && currentfield.backgroundColor !== '') {
                    bgColor = currentfield.backgroundColor;
                }
                bgColor = bgColor.replace("#", "");
                return this.getImageUrl('icon') + '/button/' + button.key + '-' + currentfield.chosenSize + '-' + bgColor + '-dark-' + currentfield.edges + '.png';
            },
            newButtonImageUrl: function(button, currentfield) {
                var bgColor = '666666';
                if (currentfield.backgroundColorType === 'default') {
                    bgColor = currentfield.defaultBackground;
                } if (currentfield.backgroundColorType == 'black') {
                    bgColor = '#000000';
                } else if (currentfield.backgroundColorType == 'gray') {
                    bgColor = '#666666';
                } if (currentfield.backgroundColorType == 'trans') {
                    bgColor = 'trans';
                }  else if (currentfield.backgroundColorType == 'linkcolor') {
                    bgColor = this.signature.settings.linkColor;
                } else if (currentfield.backgroundColorType == 'other' && currentfield.backgroundColor && currentfield.backgroundColor !== '') {
                    bgColor = currentfield.backgroundColor;
                }
                bgColor = bgColor.replace("#", "");
                var iconColor = 'FFFFFF';
                if (currentfield.iconTextColorType === 'white') {
                    iconColor = 'FFFFFF';
                } else if (currentfield.iconTextColorType == 'gray') {
                    iconColor = '666666';
                } else if (currentfield.iconTextColorType == 'darkgray') {
                    iconColor = '333333';
                } else if (currentfield.iconTextColorType == 'linkcolor') {
                    iconColor = this.signature.settings.linkColor;
                } else if (currentfield.iconTextColorType == 'other' && currentfield.iconColor && currentfield.iconColor !== '') {
                    iconColor = currentfield.iconColor;
                }
                iconColor = iconColor.replace("#", "");
                var textColor = 'FFFFFF';
                if (currentfield.iconTextColorType === 'white') {
                    textColor = 'FFFFFF';
                } else if (currentfield.iconTextColorType == 'gray') {
                    textColor = '666666';
                } else if (currentfield.iconTextColorType == 'darkgray') {
                    textColor = '333333';
                } else if (currentfield.iconTextColorType == 'linkcolor') {
                    textColor = this.signature.settings.linkColor;
                } else if (currentfield.iconTextColorType == 'other' && currentfield.textColor && currentfield.textColor !== '') {
                    textColor = currentfield.textColor;
                }
                textColor = textColor.replace("#", "");
                return this.getImageUrl('icon') + '/buttons/' + button.key + '-' + currentfield.chosenSize + '-' + bgColor + '-' + iconColor + '-' + textColor + '-' + currentfield.edges + '-' + currentfield.side + '.png';
            },
            exampleButtonImageUrl: function(button, currentfield) {
                return this.getImageUrl('icon') + '/button/' + button.key + '-small-666666-dark-round.png';
            },
            buttonImageWidth: function(button, currentfield) {
                if (button[currentfield.chosenSize].width) {
                    return button[currentfield.chosenSize].width;
                } else {
                    return 100;
                }
            },
            newButtonImageWidth: function(button, currentfield) {
                var translatedSize = 'new' + currentfield.chosenSize;
                if (button[translatedSize].width) {
                    return button[translatedSize].width;
                } else {
                    return 100;
                }
            },
            exampleButtonImageWidth: function(button, currentfield) {
                if (button.small.width) {
                    return button.small.width;
                } else {
                    return 100;
                }
            },
            buttonImageHeight: function(button, currentfield) {
                if (button[currentfield.chosenSize].height) {
                    return button[currentfield.chosenSize].height;
                } else {
                    return 40;
                }
            },
            newButtonImageHeight: function(button, currentfield) {
                var translatedSize = 'new' + currentfield.chosenSize;
                if (button[translatedSize].height) {
                    return button[translatedSize].height;
                } else {
                    return 40;
                }
            },
            exampleButtonImageHeight: function(button, currentfield) {
                if (button.small.height) {
                    return button.small.height;
                } else {
                    return 40;
                }
            },
            buttonSizeChange: function(currentfield) {
                if (this.available_buttons.hasOwnProperty(currentfield.slug)) {
                    var foundButton = null;
                    this.available_buttons[currentfield.slug].forEach(function ( button ) {
                        if (button.key === currentfield.chosen) {
                            foundButton = button;
                        }
                    }, currentfield, foundButton);
                    if (foundButton) {
                        currentfield.width = foundButton[currentfield.chosenSize].width;
                        currentfield.height = foundButton[currentfield.chosenSize].height;
                    }
                }
                return;
            },
            getIconBackgroundStyle: function(icon, iconSet, iconStyle) {
                var styles = {};
                styles.backgroundImage = 'url(' + this.load_aws_url + '/website/icons-' + iconSet + '-' + iconStyle + '.png)';
                var leftValue = '';
                var topValue = '';
                if (iconSet == 'fa' && iconStyle == 'solid') {
                    leftValue = icon.fa_solid_left * -1;
                    topValue = icon.fa_solid_top * -1;
                } else if (iconSet == 'fa' && iconStyle == 'outline') {
                    leftValue = icon.fa_outline_left * -1;
                    topValue = icon.fa_outline_top * -1;
                } else if (iconSet == 'fa' && iconStyle == 'light') {
                    leftValue = icon.fa_light_left * -1;
                    topValue = icon.fa_light_top * -1;
                } else if (iconSet == 'soc' && iconStyle == 'solid') {
                    leftValue = icon.soc_solid_left * -1;
                    topValue = icon.soc_solid_top * -1;
                }
                styles.backgroundPosition = leftValue + 'px ' + topValue + 'px';
                return styles;
            },
            newButtonSizeChange: function(currentfield) {
                if (currentfield.custom === false && this.available_buttons.hasOwnProperty(currentfield.slug)) {
                    var foundButton = null;
                    this.available_buttons[currentfield.slug].forEach(function ( button ) {
                        if (button.key === currentfield.chosen) {
                            foundButton = button;
                        }
                    }, currentfield, foundButton);
                    if (foundButton) {
                        var newWidth = foundButton['new' + currentfield.chosenSize].width;
                        var newHeight = foundButton['new' + currentfield.chosenSize].height;
                        if (currentfield.edges == 'circle') {
                            if (currentfield.chosenSize == 'small') {
                                newWidth = newWidth + 2;
                            } else if (currentfield.chosenSize == 'medium') {
                                newWidth = newWidth + 3;
                            } else if (currentfield.chosenSize == 'xlarge') {
                                newWidth = newWidth + 6;
                            } else {
                                newWidth = newWidth + 5;
                            }
                        }
                        currentfield.width = newWidth;
                        currentfield.height = newHeight;
                    }
                } else {
                    var data = { 'slug': currentfield.imageSlug, 'size': currentfield.chosenSize, 'rounded': currentfield.edges };
                    axios.post('/generator/get-button-size', data)
                    .then(function (response) {
                        if (response.data.status == 'success') {
                            currentfield.width = response.data.width / 2;
                            currentfield.height = response.data.height / 2;
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            applyButton: function(currentfield) {
                if (this.signatureid === null) {
                    alert("Please save your signature first.")
                    return;
                }
                var self = this;
                var data = { 'text1': currentfield.textValue, 'size': currentfield.chosenSize, 'rounded': currentfield.edges, 'icon': currentfield.icon, 'set': currentfield.iconSet, 'style': currentfield.iconStyle, 'signature_id': self.signatureid };
                axios.post('/generator/save-button', data)
                .then(function (response) {
                    if (response.data.status == 'success') {
                        currentfield.custom = true;
                        currentfield.width = response.data.width / 2;
                        currentfield.height = response.data.height / 2;
                        currentfield.imageSlug = response.data.slug;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            setButton: function(button, currentfield) {
                currentfield.chosen = button.key;
                currentfield.textValue = button.textValue;
                if (button[currentfield.chosenSize].width) {
                    currentfield.width = button[currentfield.chosenSize].width;
                }
                if (button[currentfield.chosenSize].height) {
                    currentfield.height = button[currentfield.chosenSize].height;
                }
                return;
            },
            setNewButton: function(button, currentfield) {
                currentfield.chosen = button.key;
                currentfield.imageSlug = button.key;
                currentfield.textValue = button.textValue;
                this.newButtonSizeChange(currentfield);
                //currentfield.textValue = button.textValue;
                // if (button[currentfield.chosenSize].width) {
                //     currentfield.width = button[currentfield.chosenSize].width;
                // }
                // if (button[currentfield.chosenSize].height) {
                //     currentfield.height = button[currentfield.chosenSize].height;
                // }
                return;
            },
            convertToNewButton: function(currentfield,valueType = null, newValue = null) {

                var newField = JSON.parse(JSON.stringify(currentfield));

                newField.category = 'Button';
                newField.type = 'newbutton';
                newField.custom = false;

                var newIconName = '';
                var newIconSet = 'fa';
                if (newField.slug == 'linkedinbutton') {
                    newIconName = 'linkedin';
                    newIconSet = 'soc';
                } else if (newField.slug == 'twitterbutton') {
                    newIconName = 'twitter';
                    newIconSet = 'soc';
                } else if (newField.slug == 'youtubebutton') {
                    newIconName = 'youtube';
                    newIconSet = 'soc';
                } else if (newField.slug == 'facebookbutton') {
                    newIconName = 'facebook';
                    newIconSet = 'soc';
                } else if (newField.slug == 'instagrambutton') {
                    newIconName = 'instagram';
                    newIconSet = 'soc';
                } else if (newField.slug == 'schedulebutton') {
                    newIconName = 'calendaralt2';
                } else if (newField.slug == 'realtorbutton') {
                    newIconName = 'home';
                } else if (newField.slug == 'portfoliobutton') {
                    newIconName = 'briefcase';
                } else if (newField.slug == 'contactbutton') {
                    newIconName = 'phonealt';
                } else if (newField.slug == 'reviewsbutton') {
                    newIconName = 'star';
                } else if (newField.slug == 'actionbutton') {
                    newIconName = 'chevrondoubleright';
                } else if (newField.slug == 'storebutton') {
                    newIconName = 'shoppingcart';
                } else if (newField.slug == 'etsybutton') {
                    newIconName = 'etsy';
                    newIconSet = 'soc';
                } else if (newField.slug == 'ebaybutton') {
                    newIconName = 'ebay';
                    newIconSet = 'soc';
                } else if (newField.slug == 'donatebutton') {
                    newIconName = 'donateheart';
                } else if (newField.slug == 'eventbutton') {
                    newIconName = 'calendarcheckalt';
                } else if (newField.slug == 'ticketbutton') {
                    newIconName = 'ticketalt';
                } else if (newField.slug == 'emailbutton') {
                    newIconName = 'envelopealt';
                } else if (newField.slug == 'websitebutton') {
                    newIconName = 'link';
                } else if (newField.slug == 'loginbutton') {
                    newIconName = 'lockalt2';
                } else if (newField.slug == 'newsletterbutton') {
                    newIconName = 'envelopeopentext';
                } else if (newField.slug == 'podcastbutton') {
                    newIconName = 'microphone';
                } else if (newField.slug == 'blogbutton') {
                    newIconName = 'pencilcircle';
                }

                var newSize = '';
                if (newField.chosenSize == 'small') {
                    newSize = 'medium';
                } else if (newField.chosenSize == 'medium') {
                    newSize = 'large';
                } else if (newField.chosenSize == 'large') {
                    newSize = 'xlarge';
                }
                
                //For social icons, you will need to change icon set!
                newField.icon = newIconName;
                newField.chosenSize = newSize;
                newField.iconSet = newIconSet;
                newField.iconStyle = "solid";
                newField.imageSlug = newField.chosen;
                newField.side = "left";
                newField.iconTextColorType = "white";
                newField.iconColor = "";
                newField.textColor = "";
                if (valueType && newValue) {
                    newField[valueType] = newValue;
                }

                this.createUndoPoint();
                this.signature.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield, fieldindex ) {
                                if(currentfield == thefield) {
                                    boxline.fields.splice(fieldindex,1,newField);
                                    this.currentfield = boxline.fields[fieldindex];
                                }
                            }, this, currentfield);
                        }, this, line);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            if(currentfield == thefield) {
                                                boxline.fields.splice(fieldindex,1,newField);
                                                this.currentfield = boxline.fields[fieldindex];
                                            }
                                        }, this, currentfield);
                                    }, this, currentfield);
                                } else {
                                    columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        if(currentfield == thefield) {
                                            columnsline.fields.splice(fieldindex,1,newField);
                                            this.currentfield = columnsline.fields[fieldindex];
                                        }
                                    }, this, currentfield);
                                }
                            }, this, line);
                        }, this, line);
                    } else {
                        line.fields.forEach(function ( thefield, fieldindex ) {
                            if(currentfield == thefield) {
                                this.signature.lines[lineindex].fields.splice(fieldindex,1,newField);
                                this.currentfield = this.signature.lines[lineindex].fields[fieldindex];
                            }
                        }, this, currentfield);
                    }
                }, this, currentfield);

                var newFieldRef = this.currentfield;

                this.newButtonSizeChange(newFieldRef);


            },
            searchIcons: function() {
                return false;
            },
            listenForKeyCommands(e) {
                // console.log(e);
                // console.log(e.ctrlKey);
                if (e.key === "z" && e.shiftKey && (e.ctrlKey || e.metaKey)) {
                    this.redoOneStep();
                    e.preventDefault();
                } else if (e.key === "z" && (e.ctrlKey || e.metaKey)) {
                    this.undoBackOneStep();
                    e.preventDefault();
                } else if (e.key === "s" && (e.ctrlKey || e.metaKey)) {
                    this.saveTemplate();
                    e.preventDefault();
                } else if(e.keyCode == 46 || e.keyCode == 8) {
                    if (document.activeElement.tagName == 'BODY') {
                        if (this.currentfield) {
                            this.removeField(this.currentfield);
                        } else if (this.currentline) {
                            this.removeLine(this.currentline);
                        }
                    }
                } else if ((e.keyCode == 27 || e.keyCode == 13 || e.key == "Enter") && this.colorPickerOpen == true) {
                    this.colorPickerOpen = false;
                    this.colorPickerType = null;
                    this.colorPickerProperty = null;
                } else if (e.keyCode == 27 && this.currentfield !== null) {
                    this.currentfield = null;
                    this.currentline = null;
                    this.designscreen = 'styles';
                } else if (e.keyCode == 27 && this.currentline !== null) {
                    this.currentfield = null;
                    this.currentline = null;
                    this.designscreen = 'styles';
                } else if (e.keyCode == 27 && this.currentcolumn !== null) {
                    this.currentfield = null;
                    this.currentline = null;
                    if (this.currentcolumn) {
                        this.currentcolumn.active = false;
                        this.currentcolumn = null;
                        this.currentcolumntable = null;
                    }
                    this.designscreen = 'styles';
                }
                //  else if (e.keyCode == 13) {
                //     if (document.activeElement.tagName !== 'BODY') {
                //         return false;
                //     }
                // }
            },
            purchaseSuccessful: function(user, organization) {
                this.user = user;
                this.organization = organization;
                this.user_id = user.id;
                this.organization_id = organization.id;
                this.purchased = true;
                if (this.templatePurchaseDesired) {
                    this.currentfield = null;
                    this.currentline = null;
                    if (this.currentcolumn) {
                        this.currentcolumn.active = false;
                        this.currentcolumn = null;
                        this.currentcolumntable = null;
                    }
                    this.signature = JSON.parse(JSON.stringify(this.templatePurchaseDesired));
                    this.showTemplateModal = false;
                    this.signatureEdited = true;
                    this.designscreen = 'styles';
                }
            },
            upgradeSuccessful: function(plan, period, templates, sharing) {
                this.purchased = true;
                this.organization.plan_name = plan;
                this.organization.period = period;
                this.organization.templates = templates;
                this.organization.sharing = sharing;
            },
            toggleStyleSettings: function() {
                this.createUndoPoint();
                this.currentfield = null;
                this.currentline = null;
                if (this.currentcolumn) {
                    this.currentcolumn.active = false;
                    this.currentcolumn = null;
                    this.currentcolumntable = null;
                }
                if (this.designscreen == 'styles') {
                    this.designscreen = 'settings';
                } else {
                    this.currentfield = null;
                    this.designscreen = 'styles';
                }
            },
            doNothing: function() {
                //No literally, don't do anything
            },
            chooseTemplate: function (template) {
                if (template.premium && this.purchased === false) {
                    this.purchaseMode = 'directpurchase';
                    this.showPurchaseModal = true;
                    this.templatePurchaseDesired = template.settings;
                } else {
                    this.createUndoPoint();
                    this.currentfield = null;
                    this.currentline = null;
                    if (this.currentcolumn) {
                        this.currentcolumn.active = false;
                        this.currentcolumn = null;
                        this.currentcolumntable = null;
                    }
                    this.signature = this.saveValuesFromOldSignature(template);
                    this.assignFieldIds();
                    //this.unique_fids = this.getFieldIds();
                    this.showTemplateModal = false;
                    this.signatureEdited = true;
                    this.designscreen = 'styles';
                    this.countUsage();
                    if (typeof gtag != "undefined") {
                        gtag('event', 'replacetemplate', {
                            'event_category': 'Designer',
                            'event_label': template.name
                        });
                    }
                    this.recalculateSignatureHeightClass();
                }
            },
            saveValuesFromOldSignature: function(template) {
                var newTemplate = JSON.parse(JSON.stringify(template.settings));
                var slugs_to_save = ['full_name','first_name','last_name','phone','mobile_phone','direct_phone','company_phone','fax','email','title','company_name','website','whole_address'];
                var saved_fields = [];
                var self = this;
                //Loop through old signature, save some values
                self.signature.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield, fieldindex ) {
                                if(thefield.slug && (slugs_to_save.indexOf(thefield.slug) !== -1 || thefield.type == 'social')){
                                    var new_saved_field = {'slug': thefield.slug, 'value': thefield.value};
                                    if (thefield.type == 'link' || thefield.type == 'social') {
                                        new_saved_field.link = thefield.link;
                                    }
                                    saved_fields.push(new_saved_field);
                                }
                            });
                        }, line, slugs_to_save, saved_fields, self);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            if(thefield.slug && (slugs_to_save.indexOf(thefield.slug) !== -1 || thefield.type == 'social')){
                                                var new_saved_field = {'slug': thefield.slug, 'value': thefield.value};
                                                if (thefield.type == 'link' || thefield.type == 'social') {
                                                    new_saved_field.link = thefield.link;
                                                }
                                                saved_fields.push(new_saved_field);
                                            }
                                        }, line, slugs_to_save, saved_fields, self);
                                    }, line, slugs_to_save, saved_fields, self);
                                } else {
                                    columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        if(thefield.slug && (slugs_to_save.indexOf(thefield.slug) !== -1 || thefield.type == 'social')){
                                            var new_saved_field = {'slug': thefield.slug, 'value': thefield.value};
                                            if (thefield.type == 'link' || thefield.type == 'social') {
                                                new_saved_field.link = thefield.link;
                                            }
                                            saved_fields.push(new_saved_field);
                                        }
                                    }, line, slugs_to_save, saved_fields, self);
                                }
                            }, line, slugs_to_save, saved_fields, self);
                        }, line, slugs_to_save, saved_fields, self);
                    } else {
                        line.fields.forEach(function ( thefield, fieldindex ) {
                            if(thefield.slug && (slugs_to_save.indexOf(thefield.slug) !== -1 || thefield.type == 'social')){
                                var new_saved_field = {'slug': thefield.slug, 'value': thefield.value};
                                if (thefield.type == 'link' || thefield.type == 'social') {
                                    new_saved_field.link = thefield.link;
                                }
                                saved_fields.push(new_saved_field);
                            }
                        }, slugs_to_save, saved_fields, self);
                    }
                }, slugs_to_save, saved_fields, self);

                //console.log(saved_fields);

                //Loop through new signature, reapply those values
                newTemplate.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield, fieldindex ) {
                                if (thefield.slug) {
                                    saved_fields.forEach(function ( saved_field, fieldindex ) {
                                        if (saved_field.slug === thefield.slug) {
                                            thefield.value = saved_field.value;
                                            if (thefield.type == 'link' || thefield.type == 'social') {
                                                thefield.link = saved_field.link;
                                            }
                                        }
                                    }, thefield);
                                }
                            });
                        }, line, slugs_to_save, saved_fields, self);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            if (thefield.slug) {
                                                saved_fields.forEach(function ( saved_field, fieldindex ) {
                                                    if (saved_field.slug === thefield.slug) {
                                                        thefield.value = saved_field.value;
                                                        if (thefield.type == 'link' || thefield.type == 'social') {
                                                            thefield.link = saved_field.link;
                                                        }
                                                    }
                                                }, thefield);
                                            }
                                        }, line, slugs_to_save, saved_fields, self);
                                    }, line, slugs_to_save, saved_fields, self);
                                } else {
                                    columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        if (thefield.slug) {
                                            saved_fields.forEach(function ( saved_field, fieldindex ) {
                                                if (saved_field.slug === thefield.slug) {
                                                    thefield.value = saved_field.value;
                                                    if (thefield.type == 'link' || thefield.type == 'social') {
                                                        thefield.link = saved_field.link;
                                                    }
                                                }
                                            }, thefield);
                                        }
                                    }, line, slugs_to_save, saved_fields, self);
                                }
                            }, line, slugs_to_save, saved_fields, self);
                        }, line, slugs_to_save, saved_fields, self);
                    } else {
                        line.fields.forEach(function ( thefield, fieldindex ) {
                            if (thefield.slug) {
                                saved_fields.forEach(function ( saved_field, fieldindex ) {
                                    if (saved_field.slug === thefield.slug) {
                                        thefield.value = saved_field.value;
                                        if (thefield.type == 'link' || thefield.type == 'social') {
                                            thefield.link = saved_field.link;
                                        }
                                    }
                                }, thefield);
                            }
                        }, slugs_to_save, saved_fields, self);
                    }
                }, slugs_to_save, saved_fields, self);

                newTemplate.settings.fontColor = self.signature.settings.fontColor;
                newTemplate.settings.linkColor = self.signature.settings.linkColor;
                newTemplate.settings.socialBackgroundColor = self.signature.settings.socialBackgroundColor;
                newTemplate.settings.socialIconColorType = self.signature.settings.socialIconColorType;
                newTemplate.settings.socialIconColor = self.signature.settings.socialIconColor;
                newTemplate.settings.recentColors = self.signature.settings.recentColors;

                //Return the edited template with personalized values
                return newTemplate;
            },
            getFieldIds: function() {
                var self = this;
                var unique_fids = [];
                self.signature.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield, fieldindex ) {
                                if(thefield.fid){
                                    unique_fids.push(thefield.fid);
                                }
                            });
                        }, line, unique_fids, self);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            if(thefield.fid){
                                                unique_fids.push(thefield.fid);
                                            }
                                        }, line, unique_fids, self);
                                    }, line, unique_fids, self);
                                } else {
                                    columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        if(thefield.fid){
                                            unique_fids.push(thefield.fid);
                                        }
                                    }, line, unique_fids, self);
                                }
                            }, line, unique_fids, self);
                        }, line, unique_fids, self);
                    } else {
                        line.fields.forEach(function ( thefield, fieldindex ) {
                            if(thefield.fid){
                                unique_fids.push(thefield.fid);
                            }
                        }, unique_fids, self);
                    }
                }, unique_fids, self);
                return unique_fids;
            },
            assignFieldIds: function() {
                var self = this;
                self.signature.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield, fieldindex ) {
                                if(thefield.fid == ''){
                                    self.createNewFieldId(thefield);
                                }
                            });
                        }, line, self);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            if(thefield.fid == ''){
                                                self.createNewFieldId(thefield);
                                            }
                                        }, line, self);
                                    }, line, self);
                                } else {
                                    columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        if(thefield.fid == ''){
                                            self.createNewFieldId(thefield);
                                        }
                                    }, line, self);
                                }
                            }, line, self);
                        }, line, self);
                    } else {
                        line.fields.forEach(function ( thefield, fieldindex ) {
                            if(thefield.fid == ''){
                                self.createNewFieldId(thefield);
                            }
                        }, self);
                    }
                }, self);
                return;
            },
            createNewFieldId: function(field) {
                let result = '';
                var characters = '0123456789abcdefghijklmnopqrstuvwxyz';
                var charactersLength = characters.length;
                var limit = 100; // max tries to create unique id
                var attempts = 0; // how many attempts
                var fid = false;
                while(!fid && attempts < limit) {
                    fid = '';
                    let counter = 0;
                    while (counter < 6) {
                        fid += characters.charAt(Math.floor(Math.random() * charactersLength));
                        counter += 1;
                    }
                    let match = this.unique_fids.find(function(item) {
                        return item === fid;
                    });
                    if(match) { // check unique
                        fid = false; // reset id
                        attempts++; // record failed attempt
                    }
                }
                if (fid) {
                    field.fid = fid;
                    this.unique_fids.push(fid);
                }
                return;
                // let counter = 0;
                // while (counter < 6) {
                //     result += characters.charAt(Math.floor(Math.random() * charactersLength));
                //     counter += 1;
                // }
                
            },
            // checkId = function(id, existing = []) {
            //     let match = existing.find(function(item) {
            //         return item === id;
            //     });
            //     return match ? false : true;
            // };
            selectSingle(value, launch_template_modal) {
                this.single_signature = value;
                if (launch_template_modal === true) {
                    this.showStartModal = false;
                    this.showTemplateModal = true;
                }
            },
            menuToggle: function() {
                this.previewActive = false;
                if (this.designscreen == 'menu') {
                    this.designscreen = this.lastscreen;
                } else {
                    this.lastscreen = this.designscreen;
                    this.designscreen = 'menu';
                }
            },
            fieldPlaceholder(currentfield) {
                if (this.single_signature && currentfield.placeholder) {
                    return currentfield.placeholder;
                } else {
                    return '';
                }
            },
            chooseDesignScreen(screen) {
                this.designscreen = screen;
                this.previewActive = false;
                this.currentfield = null;
                if (this.currentcolumn) {
                    this.currentcolumn.active = false;
                    this.currentcolumn = null;
                    this.currentcolumntable = null;
                }
            },
            togglePreview: function() {
                if (this.previewActive) {
                    this.signature = JSON.parse(JSON.stringify(this.signatureBackup));
                    this.designscreen = 'styles';
                    this.previewActive = false;
                    this.validToCopy = true;
                    this.triedToSubmit = false;
                    this.statsEmailValid = true;
                    //this.clearInvalidFields();
                } else {
                    this.currentfield = null;
                    this.currentline = null;
                    if (this.currentcolumn) {
                        this.currentcolumn.active = false;
                        this.currentcolumn = null;
                        this.currentcolumntable = null;
                    }
                    this.signatureBackup = JSON.parse(JSON.stringify(this.signature));
                    this.previewActive = true;
                }
                this.checkForEditableRequiredEmail('truefalse');
            },
            // columnLeftStyleValue: function(column) {
            //     if (column.borderLeft && column.borderLeft > 0) {
            //         var newValue = column.borderLeft * -1;
            //         console.log(newValue);
            //         return newValue + 'px';
            //     } else {
            //         return null;
            //     }
            // },
            toggleValue: function(object, property, value, valDefault) {
                if (object[property] === value) {
                    object[property] = valDefault;
                } else {
                    object[property] = value;
                }
            },
            changeHover: function(item,value) {
                item.hover = value;
            },
            launchFeatureModal: function(featureModalType) {
                this.featureModalType = featureModalType;
                this.featureModalTypeSpecific = null;
                this.featureModal = true;
            },
            launchAddField: function(line, allowColumns, allowBox, newLine = false) {
                this.addFieldAllowColumns = allowColumns;
                this.addFieldAllowBox = allowBox;
                this.addFieldNewLine = newLine;
                this.lineToAddFieldTo = line;
                this.showAddFieldModal = true;
            },
            addField: function(field) {
                if (field.premium && this.purchased === false) {
                    // this.purchaseMode = 'directpurchase';
                    // this.showPurchaseModal = true;
                    if (field.type == 'columns') {
                        this.featureModalType = 'columns';
                        this.showAddFieldModal = false;
                        this.featureModal = true;
                    }
                    if (field.type == 'box') {
                        this.featureModalType = 'box';
                        this.showAddFieldModal = false;
                        this.featureModal = true;
                    }
                    if (field.type == 'icon') {
                        this.featureModalType = 'icon';
                        this.showAddFieldModal = false;
                        this.featureModal = true;
                    }
                    if (field.type == 'button') {
                        this.featureModalType = 'button';
                        this.featureModalTypeSpecific = field.slug;
                        this.showAddFieldModal = false;
                        this.featureModal = true;
                    }
                    if (field.type == 'newbutton') {
                        this.featureModalType = 'button';
                        this.featureModalTypeSpecific = field.slug;
                        this.showAddFieldModal = false;
                        this.featureModal = true;
                    }
                    if (field.type == 'select') {
                        this.featureModalType = 'choices';
                        this.showAddFieldModal = false;
                        this.featureModal = true;
                    }
                    if (field.type == 'selectimage') {
                        this.featureModalType = 'imagechoices';
                        this.showAddFieldModal = false;
                        this.featureModal = true;
                    }
                    // this.templatePurchaseDesired = template;
                } else if (this.purchased === false && this.before_free_limit === false && this.fields_used >= 10) {
                    this.featureModalType = 'field_limit';
                    this.showAddFieldModal = false;
                    this.featureModal = true;
                } else if (this.purchased === false && this.before_free_limit === false && this.images_used >= 2 && field.type == 'image') {
                    this.featureModalType = 'field_limit';
                    this.showAddFieldModal = false;
                    this.featureModal = true;
                } else {
                    this.createUndoPoint();
                    this.createNewFieldId(field);
                    this.currentfield = null;
                    this.designscreen = 'none';
                    if (field.type == 'box' || field.type == 'columns') {
                        let newLine = JSON.parse(JSON.stringify(field));
                        this.signature.lines.forEach(function ( line, index ) {
                            if (line.type == 'columns') {
                                line.columns.forEach(function ( column, columnindex ) {
                                    column.lines.forEach(function ( columnsline, columnlineindex ) {
                                        if (columnsline.type == 'box') {
                                            columnsline.lines.forEach(function ( boxline, boxlineindex ) {
                                                if(this.lineToAddFieldTo === boxline) {
                                                    this.signature.lines[index].columns[columnindex].lines[boxlineindex].lines.splice(boxlineindex, 1, newLine);
                                                }
                                            }, this, line, newLine);
                                        } else {
                                            if(this.lineToAddFieldTo === columnsline) {
                                                this.signature.lines[index].columns[columnindex].lines.splice(columnlineindex, 1, newLine);
                                            }
                                        }
                                    }, this, line, index, newLine);
                                }, this, line, index, newLine);
                            } else {
                                if(this.lineToAddFieldTo === line) {
                                    this.signature.lines.splice(index, 1, newLine);
                                }
                            }
                        }, this, field, newLine);
                        if (field.type == 'box') {
                            this.currentfield = null;
                            this.designscreen = 'lineEdit';
                            this.currentline = newLine;
                            this.currentline.current = true;
                        } else if (field.type == 'columns') {
                            this.currentline = null;
                            this.currentfield = null;
                            this.designscreen = 'columnEdit';
                            this.currentcolumn = newLine.columns[0];
                            this.currentcolumntable = newLine;
                            this.currentcolumn.active = true;
                            // this.currentfield = null;
                            // this.designscreen = 'lineEdit';
                            // this.currentline = newLine;
                            // this.currentline.current = true;
                        }
                        this.lineToAddFieldTo = null;
                        this.showAddFieldModal = false;
                    } else {
                        this.$nextTick(function () {
                            let newField = JSON.parse(JSON.stringify(field));
                            var newLength = this.lineToAddFieldTo.fields.push(newField);
                            var newFieldIndex = newLength - 1;
                            newField.current = true;
                            this.currentfield = this.lineToAddFieldTo.fields[newFieldIndex];
                            this.designscreen = 'fieldEdit';
                            this.currentline = null;
                            this.lineToAddFieldTo = null;
                            this.showAddFieldModal = false;
                        });
                    }
                }
                this.countUsage();
                this.recalculateSignatureHeightClass();
            },
            disabledIfComplex: function(field) {
                if (field.type == 'box') {
                    if (field.premium && !this.purchased) {
                        return false;
                    } else if (this.addFieldAllowBox) {
                        return false;
                    } else {
                        return true;
                    }
                } else if (field.type == 'columns') {
                    if (field.premium && !this.purchased) {
                        return false;
                    } else if (this.addFieldAllowColumns) {
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return false;
                }
            },
            dragStart: function() {
                this.createUndoPoint();
                this.dragging = true;
            },
            dragEnd: function() {
                this.dragging = false;

            },
            addLine: function(currentLine, aboveOrBelow) {
                this.createUndoPoint();
                let newLine = JSON.parse(JSON.stringify(this.default_line));
                if (currentLine === null) {
                    if (aboveOrBelow == 'above') {
                        this.signature.lines.splice(0,0,newLine);
                        this.launchAddField(this.signature.lines[0], true, true, true);
                    } else {
                        this.signature.lines.push(newLine);
                        this.launchAddField(this.signature.lines[this.signature.lines.length-1], true, true, true);
                    }
                } else {
                    var newLineIndex = 0;
                    var lineAdded = false;
                    this.signature.lines.forEach(function ( line, index ) {
                        if (line.type == 'columns') {
                            if(currentLine === line && lineAdded === false) {
                                var newIndex = null;
                                if (aboveOrBelow == 'above') {
                                    newIndex = index;
                                } else {
                                    newIndex = index + 1;
                                }
                                this.signature.lines.splice(newIndex, 0, newLine);
                                lineAdded = true;
                                this.launchAddField(this.signature.lines[newIndex], true, true, true);
                            }
                            line.columns.forEach(function ( column, columnindex ) {
                                column.lines.forEach(function ( columnsline, columnlineindex ) {
                                    if (columnsline.type == 'box') {
                                        columnsline.lines.forEach(function ( boxline, boxlineindex ) {
                                            if(currentLine === boxline && lineAdded === false) {
                                                var newIndex = null;
                                                if (aboveOrBelow == 'above') {
                                                    newIndex = boxlineindex;
                                                } else {
                                                    newIndex = boxlineindex + 1;
                                                }
                                                this.signature.lines[index].columns[columnindex].lines[columnlineindex].lines.splice(newIndex, 0, newLine);
                                                lineAdded = true;
                                                this.launchAddField(this.signature.lines[index].columns[columnindex].lines[columnlineindex].lines[newIndex], false, false, true);
                                            }
                                        }, this, line, currentLine, aboveOrBelow, newLine, lineAdded);
                                    } else {
                                        if(currentLine === columnsline && lineAdded === false) {
                                            var newIndex = null;
                                            if (aboveOrBelow == 'above') {
                                                newIndex = columnlineindex;
                                            } else {
                                                newIndex = columnlineindex + 1;
                                            }
                                            this.signature.lines[index].columns[columnindex].lines.splice(newIndex, 0, newLine);
                                            lineAdded = true;
                                            this.launchAddField(this.signature.lines[index].columns[columnindex].lines[newIndex], false, true, true);
                                        }
                                    }
                                }, this, line, index, currentLine, aboveOrBelow, newLine, lineAdded);
                            }, this, line, index, currentLine, aboveOrBelow, newLine, lineAdded);
                        } else if (line.type == 'box') {
                            if(currentLine === line && lineAdded === false) {
                                var newIndex = null;
                                if (aboveOrBelow == 'above') {
                                    newIndex = index;
                                } else {
                                    newIndex = index + 1;
                                }
                                this.signature.lines.splice(newIndex, 0, newLine);
                                lineAdded = true;
                                this.launchAddField(this.signature.lines[newIndex], true, true, true);
                            }
                            line.lines.forEach(function ( boxline, boxlineindex ) {
                                if(currentLine === boxline && lineAdded === false) {
                                    var newIndex = null;
                                    if (aboveOrBelow == 'above') {
                                        newIndex = boxlineindex;
                                    } else {
                                        newIndex = boxlineindex + 1;
                                    }
                                    this.signature.lines[index].lines.splice(newIndex, 0, newLine);
                                    lineAdded = true;
                                    this.launchAddField(this.signature.lines[index].lines[newIndex], false, false, true);
                                }
                            }, this, line, currentLine, aboveOrBelow, newLine, lineAdded);
                        } else {
                            if(currentLine === line && lineAdded === false) {
                                var newIndex = null;
                                if (aboveOrBelow == 'above') {
                                    newIndex = index;
                                } else {
                                    newIndex = index + 1;
                                }
                                this.signature.lines.splice(newIndex, 0, newLine);
                                lineAdded = true;
                                this.launchAddField(this.signature.lines[newIndex], true, true, true);
                            }
                        }
                    }, this, currentLine, aboveOrBelow, newLine, lineAdded);
                }
                this.recalculateSignatureHeightClass();
            },
            addLineToBox: function(parentLine) {
                this.createUndoPoint();
                let newLine = JSON.parse(JSON.stringify(this.default_line));
                if (parentLine) {
                    parentLine.lines.push(newLine);
                    this.launchAddField(parentLine.lines[parentLine.lines.length-1], false, false, true);
                } else {
                    this.signature.lines.push(newLine);
                    this.launchAddField(this.signature.lines[this.signature.lines.length-1], true, true, true);
                }
                this.recalculateSignatureHeightClass();
            },
            addLineToColumn: function(column) {
                this.createUndoPoint();
                let newLine = JSON.parse(JSON.stringify(this.default_line));
                if (column) {
                    column.lines.push(newLine);
                    this.launchAddField(column.lines[column.lines.length-1], false, true, true);
                }
                this.recalculateSignatureHeightClass();
            },
            addColumn: function(currentColumn, rightOrLeft) {
                this.createUndoPoint();
                let newColumn = JSON.parse(JSON.stringify(this.default_column));
                var newColumnIndex = 0;
                var columnAdded = false;
                this.signature.lines.forEach(function ( line, index ) {
                    if (line.type == 'columns') {
                        line.columns.forEach(function ( column, columnindex ) {
                            if(currentColumn === column && columnAdded === false) {
                                var newIndex = null;
                                if (rightOrLeft == 'left') {
                                    newIndex = columnindex;
                                } else {
                                    newIndex = columnindex + 1;
                                }
                                this.signature.lines[index].columns.splice(newIndex, 0, newColumn);
                                columnAdded = true;
                            }
                        }, this, line, index, currentColumn, rightOrLeft, newColumn, columnAdded);
                    }
                }, this, currentColumn, rightOrLeft, newColumn, columnAdded);
            },
            editField: function(field) {
                this.createUndoPoint();
                this.currentline = null;
                if (this.currentcolumn) {
                    this.currentcolumn.active = false;
                    this.currentcolumn = null;
                    this.currentcolumntable = null;
                }
                if (this.currentfield == field) {
                    field.current = false;
                    this.currentfield = null;
                    this.designscreen = 'styles';
                } else {
                    this.currentfield = null;
                    this.designscreen = 'none';
                    this.colorPickerOpen = false;
                    this.colorPickerType = null;
                    this.colorPickerProperty = null;
                    this.signature.lines.forEach(function ( line ) {
                        if (line.type == 'box') {
                            line.lines.forEach(function ( boxline ) {
                                boxline.fields.forEach(function ( thefield ) {
                                    field.current = false;
                                }, this, field);
                            }, this, field, line);
                        } else if (line.type == 'columns') {
                            line.columns.forEach(function ( column ) {
                                column.lines.forEach(function ( columnsline ) {
                                    if (columnsline.type == 'box') {
                                        columnsline.lines.forEach(function ( boxline ) {
                                            boxline.fields.forEach(function ( thefield ) {
                                                field.current = false;
                                            }, this, field);
                                        }, this, field);
                                    } else {
                                        columnsline.fields.forEach(function ( thefield ) {
                                            field.current = false;
                                        }, this, field);
                                    }
                                }, this, field, line);
                            }, this, field, line);
                        } else {
                            line.fields.forEach(function ( thefield ) {
                                field.current = false;
                            }, this, field);
                        }
                    }, this, field);
                    this.$nextTick(function () {
                        field.current = true;
                        this.currentfield = field;
                        this.designscreen = 'fieldEdit';
                    });
                }
            },
            editLine: function (line) {
                this.createUndoPoint();
                this.currentfield = null;
                if (this.currentcolumn) {
                    this.currentcolumn.active = false;
                    this.currentcolumn = null;
                    this.currentcolumntable = null;
                }
                if (this.currentline == line) {
                    this.currentline = null;
                    this.designscreen = 'styles';
                } else {
                    this.colorPickerOpen = false;
                    this.colorPickerType = null;
                    this.colorPickerProperty = null;
                    this.currentline = line;
                    this.designscreen = 'lineEdit';
                }
            },
            editColumn: function (column, table) {
                this.createUndoPoint();
                this.currentfield = null;
                this.currentline = null;
                if (this.currentcolumn == column) {
                    this.currentcolumn.active = false;
                    this.currentcolumn = null;
                    this.currentcolumntable = null;
                    this.designscreen = 'styles';
                } else {
                    if (this.currentcolumn) {
                        this.currentcolumn.active = false;
                        this.currentcolumn = null;
                        this.currentcolumntable = null;
                    }
                    this.colorPickerOpen = false;
                    this.colorPickerType = null;
                    this.colorPickerProperty = null;
                    this.currentcolumn = column;
                    this.currentcolumntable = table;
                    this.currentcolumn.active = true;
                    this.designscreen = 'columnEdit';
                }
            },
            createUndoPoint: function() {
                this.recentlySaved = false;
                this.signaturePastVersions.unshift(JSON.parse(JSON.stringify(this.signature)));
                if (this.signaturePastVersions.length > 20) this.signaturePastVersions.length = 20;
                this.signatureFutureVersions = [];
            },
            undoBackOneStep: function() {
                this.currentfield = null;
                this.currentline = null;
                if (this.currentcolumn) {
                    this.currentcolumn.active = false;
                    this.currentcolumn = null;
                    this.currentcolumntable = null;
                }
                this.designscreen = 'styles';
                //https://redux.js.org/recipes/implementing-undo-history
                if (this.signaturePastVersions.length > 0) {
                    this.recentlySaved = false;
                    this.signatureFutureVersions.unshift(JSON.parse(JSON.stringify(this.signature)));
                    if (this.signatureFutureVersions.length > 20) this.signatureFutureVersions.length = 20;

                    this.signature = JSON.parse(JSON.stringify(this.signaturePastVersions[0]));
                    this.signaturePastVersions.shift();
                }
                this.countUsage();
            },
            redoOneStep: function() {
                if (this.signatureFutureVersions.length > 0) {
                    this.recentlySaved = false;
                    this.signaturePastVersions.unshift(JSON.parse(JSON.stringify(this.signature)));
                    if (this.signaturePastVersions.length > 20) this.signaturePastVersions.length = 20;
                    this.signature = JSON.parse(JSON.stringify(this.signatureFutureVersions[0]));
                    this.signatureFutureVersions.shift();
                }
                this.countUsage();
            },
            removeField: function(field) {
                this.createUndoPoint();
                this.signature.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield, fieldindex ) {
                                if(field == thefield) {
                                    boxline.fields.splice(fieldindex,1);
                                }
                            }, this, field);
                        }, this, line);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield, fieldindex ) {
                                            if(field == thefield) {
                                                boxline.fields.splice(fieldindex,1);
                                            }
                                        }, this, field);
                                    }, this, field);
                                } else {
                                    columnsline.fields.forEach(function ( thefield, fieldindex ) {
                                        if(field == thefield) {
                                            columnsline.fields.splice(fieldindex,1);
                                        }
                                    }, this, field);
                                }
                            }, this, line);
                        }, this, line);
                    } else {
                        line.fields.forEach(function ( thefield, fieldindex ) {
                            if(field == thefield) {
                                this.signature.lines[lineindex].fields.splice(fieldindex,1);
                            }
                        }, this, field);
                    }
                }, this, field);
                this.currentfield = null;
                this.designscreen = 'styles';
                this.countUsage();
                this.recalculateSignatureHeightClass();
            },
            removeLine: function() {
                this.createUndoPoint();
                this.signature.lines.forEach(function ( line, lineindex ) {
                    if(this.currentline == line) {
                        this.signature.lines.splice(lineindex,1);
                    } else {
                        if (line.type == 'box') {
                            line.lines.forEach(function ( boxline, boxlineindex ) {
                                if(this.currentline == boxline) {
                                    this.signature.lines[lineindex].lines.splice(boxlineindex,1);
                                }
                            }, this, lineindex);
                        } else if (line.type == 'columns') {
                            line.columns.forEach(function ( column, columnindex ) {
                                column.lines.forEach(function ( columnsline, columnslineindex ) {
                                    if (columnsline.type == 'box') {
                                        if(this.currentline == columnsline) {
                                            this.signature.lines[lineindex].columns[columnindex].lines.splice(columnslineindex,1);
                                        } else {
                                            columnsline.lines.forEach(function ( boxline, boxlineindex ) {
                                                if(this.currentline == boxline) {
                                                    this.signature.lines[lineindex].columns[columnindex].lines[columnslineindex].lines.splice(boxlineindex,1);
                                                }
                                            }, this, lineindex, columnslineindex);
                                        }
                                    } else {
                                        if(this.currentline == columnsline) {
                                            this.signature.lines[lineindex].columns[columnindex].lines.splice(columnslineindex,1);
                                        }
                                    }
                                }, this, lineindex);
                            }, this, lineindex);
                        }
                    }
                }, this);
                this.currentline = null;
                this.designscreen = 'styles';
                this.countUsage();
                this.recalculateSignatureHeightClass();
            },
            removeColumn: function() {
                this.createUndoPoint();
                var columnWidth = this.currentcolumn.width;
                var deletedColumnsField = false;
                this.signature.lines.forEach(function ( line, lineindex ) {
                    if (line.type == 'columns') {
                        line.columns.forEach(function ( column, columnindex ) {
                            if(this.currentcolumn == column) {
                                this.signature.lines[lineindex].columns.splice(columnindex,1);
                                if (this.signature.lines[lineindex].columns.length == 0) {
                                    this.signature.lines.splice(lineindex,1);
                                    deletedColumnsField = true;
                                }
                            }
                        }, this, lineindex);
                    }
                }, this);
                if (deletedColumnsField === false) {
                    this.currentcolumntable.width = this.currentcolumntable.width - columnWidth;
                }
                this.currentcolumn = null;
                this.currentcolumntable = null;
                this.designscreen = 'styles';
                this.countUsage();
                this.recalculateSignatureHeightClass();
            },
            chooseIcon: function(icon) {
                if (this.iconModalInsert == 'before') {
                    this.currentfield.beforeIconSet = icon.set;
                    this.currentfield.beforeIconStyle = this.iconStyle;
                    this.currentfield.beforeIcon = icon.icon;
                    this.currentfield.beforeIconOrigWidth = icon.width;
                    this.currentfield.beforeIconOrigHeight = icon.height;
                } else if (this.iconModalInsert == 'after') {
                    this.currentfield.afterIconSet = icon.set;
                    this.currentfield.afterIconStyle = this.iconStyle;
                    this.currentfield.afterIcon = icon.icon;
                    this.currentfield.afterIconOrigWidth = icon.width;
                    this.currentfield.afterIconOrigHeight = icon.height;
                } else if (this.iconModalInsert == 'field') {
                    this.currentfield.iconSet = icon.set;
                    this.currentfield.iconStyle = this.iconStyle;
                    this.currentfield.icon = icon.icon;
                    this.currentfield.iconOrigWidth = icon.width;
                    this.currentfield.iconOrigHeight = icon.height;
                }
                this.showIconModal = false;
            },
            checkTransparentColor: function(type) {
                if (this.currentfield && type == 'social') {
                    if (this.signature.settings.socialIconColorType == 'trans' && this.signature.settings.socialIconColor == '') {
                        this.signature.settings.socialIconColor = '#666666';
                    }
                } else if (this.currentfield && type == 'newbutton') {
                    if (this.currentfield.backgroundColorType == 'trans' && this.currentfield.iconTextColorType == 'white') {
                        this.currentfield.iconTextColorType = 'gray';
                    }
                }
            },
            currentLineClass: function(line) {
                if (this.currentline && this.designscreen == 'lineEdit' && this.currentline === line) {
                    return true;
                } else {
                    return false;
                }
            },
            currentColumnClass: function(column) {
                if (this.currentcolumn && this.designscreen == 'columnEdit' && this.currentcolumn === column) {
                    return true;
                } else {
                    return false;
                }
            },
            currentFieldClass: function(field) {
                if (this.currentfield && this.designscreen == 'fieldEdit' && this.currentfield === field) {
                    return true;
                } else {
                    return false;
                }
            },
            fieldTypeClass: function(field) {
                return 'field-' + field.type;
            },
            hoverFieldClass: function(field) {
                if (field.hover && field.hover == true) {
                    return true;
                } else {
                    return false;
                }
            },
            fieldHoverOn: function(field) {
                field.hover = true;
            },
            fieldHoverOff: function(field) {
                field.hover = false;
            },
            tabActiveClass: function (screen, type) {
                if (type == 'screen') {
                    if (this.screen == screen && this.previewActive === false) {
                        return "active";
                    }
                } else if (type == 'designscreen') {
                    if (this.designscreen == screen && this.previewActive === false) {
                        return "active";
                    }
                }
            },
            selectContainingLine: function() {
                var foundLine = null;
                this.signature.lines.forEach(function ( line ) {
                    if (line.type == 'box') {
                        line.lines.forEach(function ( boxline ) {
                            boxline.fields.forEach(function ( thefield ) {
                                if (this.currentfield === thefield) {
                                    foundLine = boxline;
                                }
                            }, this, foundLine);
                        }, this, line, foundLine);
                    } else if (line.type == 'columns') {
                        line.columns.forEach(function ( column ) {
                            column.lines.forEach(function ( columnsline ) {
                                if (columnsline.type == 'box') {
                                    columnsline.lines.forEach(function ( boxline ) {
                                        boxline.fields.forEach(function ( thefield ) {
                                            if (this.currentfield === thefield) {
                                                foundLine = boxline;
                                            }
                                        }, this, foundLine);
                                    }, this, foundLine);
                                } else {
                                    columnsline.fields.forEach(function ( thefield ) {
                                        if (this.currentfield === thefield) {
                                            foundLine = columnsline;
                                        }
                                    }, this, foundLine);
                                }
                            }, this, line, foundLine);
                        }, this, line, foundLine);
                    } else {
                        line.fields.forEach(function ( thefield ) {
                            if (this.currentfield === thefield) {
                                foundLine = line;
                            }
                        }, this, foundLine);
                    }
                }, this, foundLine);

                if (foundLine) {
                    this.currentfield = null;
                    this.colorPickerOpen = false;
                    this.colorPickerType = null;
                    this.colorPickerProperty = null;
                    this.currentline = foundLine;
                    this.designscreen = 'lineEdit';
                }
            },
            updateColor: function(color) {
                clearTimeout(this.colorTimeout);
                this.colorTimeout = setTimeout(() => {
                    if (color.source === 'hsl' && color.oldHue > 0 && (color.hex == '#000000' || color.hex == '#FFFFFF') ) {
                        return;
                    }
                    if (this.colorPickerType == 'line' && this.currentline) {
                        this.currentline[this.colorPickerProperty] = color.hex;
                    }
                    if (this.colorPickerType == 'column' && this.currentcolumn) {
                        this.currentcolumn[this.colorPickerProperty] = color.hex;
                    }
                    if (this.colorPickerType == 'columntable' && this.currentcolumntable) {
                        this.currentcolumntable[this.colorPickerProperty] = color.hex;
                    }
                    if (this.colorPickerType == 'field' && this.currentfield) {
                        this.currentfield[this.colorPickerProperty] = color.hex;
                    }
                    if (this.colorPickerType == 'setting') {
                        this.signature.settings[this.colorPickerProperty] = color.hex;
                    }
                }, 150);
            },
            updateFromRecent: function(color) {
                if (this.colorPickerType == 'line' && this.currentline) {
                    this.currentline[this.colorPickerProperty] = color;
                }
                if (this.colorPickerType == 'column' && this.currentcolumn) {
                    this.currentcolumn[this.colorPickerProperty] = color;
                }
                if (this.colorPickerType == 'columntable' && this.currentcolumntable) {
                    this.currentcolumntable[this.colorPickerProperty] = color;
                }
                if (this.colorPickerType == 'field' && this.currentfield) {
                    this.currentfield[this.colorPickerProperty] = color;
                }
                if (this.colorPickerType == 'setting') {
                    this.signature.settings[this.colorPickerProperty] = color;
                }
                this.hidePicker();
            },
            showTheColorPicker: function(index,property) {
                if (this.colorPickerProperty == property) {
                    if (this.colorPickerType == 'line' && this.currentline && this.currentline == index) {
                        return true;
                    } else if (this.colorPickerType == 'column' && this.currentcolumn && this.currentcolumn == index) {
                        return true;
                    } else if (this.colorPickerType == 'columntable' && this.currentcolumntable && this.currentcolumntable == index) {
                        return true;
                    } else if (this.colorPickerType == 'field' && this.currentfield && this.currentfield == index) {
                        return true;
                    } else if (this.colorPickerType == 'setting') {
                        return true;
                    } else {
                        return false;
                    }
                }
                return false;
            },
            //https://codepen.io/Brownsugar/pen/NaGPKy
            showPicker(type, property) {
                //document.addEventListener('click', this.documentClick); //uses refs
                this.colorPickerOpen = true;
                this.colorPickerType = type;
                this.colorPickerProperty = property;
                //line[property + 'Picker'] = true;
            },
            hidePicker() {
                var color = null;
                if (this.colorPickerType == 'line' && this.currentline) {
                    color = this.currentline[this.colorPickerProperty];
                }
                if (this.colorPickerType == 'column' && this.currentcolumn) {
                    color = this.currentcolumn[this.colorPickerProperty];
                }
                if (this.colorPickerType == 'columntable' && this.currentcolumntable) {
                    color = this.currentcolumntable[this.colorPickerProperty];
                }
                if (this.colorPickerType == 'field' && this.currentfield) {
                    color = this.currentfield[this.colorPickerProperty];
                }
                if (this.colorPickerType == 'setting') {
                    color = this.signature.settings[this.colorPickerProperty];
                }
                if (color) {
                    if(this.signature.settings.recentColors.indexOf(color) != -1) {  
                        this.signature.settings.recentColors.splice(this.signature.settings.recentColors.indexOf(color), 1);
                        this.signature.settings.recentColors.unshift(color);
                    } else {
                        this.signature.settings.recentColors.unshift(color);
                        if (this.signature.settings.recentColors.length > 12) this.signature.settings.recentColors.length = 12;
                    }
                }
                this.colorPickerOpen = false;
                this.colorPickerType = null;
                this.colorPickerProperty = null;
                //line[property + 'Picker'] = false;
            },
            togglePicker(type, property) {
                this.colorPickerOpen ? this.hidePicker() : this.showPicker(type, property);
            },
            updateRelatedFields(currentline, type, field) {
                if (currentline[type + 'Locked']) {
                    currentline[type + 'Top'] = currentline[field];
                    currentline[type + 'Right'] = currentline[field];
                    currentline[type + 'Bottom'] = currentline[field];
                    currentline[type + 'Left'] = currentline[field];
                }
            },
            // documentClick(e) {
            //     console.log(e.target);
            //     console.log(this.$refs);
            //     var el = this.$refs.colorpicker,
            //         target = e.target;
            //     if (el !== target && !el.contains(target)) {
            //         this.hidePicker();
            //     }
            // },
            calculateColumnWidth: function(mode, column = null, columnindex = null) {
                var numberOfColumns = this.currentcolumntable.columns.length;
                var fullTableWidth = 0;
                this.currentcolumntable.columns.forEach(function ( onecolumn, onecolumnindex ) {
                    fullTableWidth = fullTableWidth + parseInt(onecolumn.width);
                }, fullTableWidth);
                if (mode == 'all-columns') {
                    var columnIndexToUpdate = numberOfColumns - 1;
                    var widthNoLastColumn = fullTableWidth - this.currentcolumntable.columns[columnIndexToUpdate].width;
                    var newWidth = 0;
                    if (this.currentcolumntable.width) {
                        newWidth = this.currentcolumntable.width - widthNoLastColumn;
                    } else if (this.signature.settings.width) {
                        newWidth = this.signature.settings.width - widthNoLastColumn;
                    }
                    if (newWidth < 1) {
                        newWidth = 1;
                    }
                    this.currentcolumntable.columns[columnIndexToUpdate].width = newWidth;
                } else if (mode == 'column') {
                    this.currentcolumntable.width = fullTableWidth;
                }
            },
            // columnWidthNoPadding: function(column) {
            //     var newWidth = column.width;
            //     if (column.paddingLeft && column.paddingLeft > 0) {
            //         newWidth = newWidth - column.paddingLeft;
            //     }
            //     if (column.paddingRight && column.paddingRight > 0) {
            //         newWidth = newWidth - column.paddingRight;
            //     }
            //     return newWidth;
            // },
            resizableWidth: function(width, withPx = false) {
                if (width) {
                    var newWidth = width;
                    // if (this.signature.settings.paddingLeft) {
                    //     newWidth = newWidth - this.signature.settings.paddingLeft;
                    // }
                    // if (this.signature.settings.paddingRight) {
                    //     newWidth = newWidth - this.signature.settings.paddingRight;
                    // }
                    if (withPx) {
                        return newWidth + 'px';
                    } else {
                        return newWidth;
                    }
                } else {
                    if (withPx) {
                        return '100%';
                    } else {
                        return 'auto';
                    }
                }
            },
            hasWidth: function(width) {
                if (width && width !== '') {
                    return true;
                } else {
                    return false;
                }
            },
            toggleSelfHosting: function(mode) {
                if (this.currentfield.selfHosted === true) {
                    if (mode == 'image' && this.currentfield.type == "image") {
                        if (this.currentfield.url && this.currentfield.selfHostedUrl == '') {
                            this.currentfield.selfHostedUrl = this.getImageUrl('image') + "/" + this.currentfield.url;
                        }
                        if (this.currentfield.width && this.currentfield.originalWidth && this.currentfield.originalHeight) {
                            if (this.currentfield.selfHostedWidth == '') {
                                this.currentfield.selfHostedWidth = this.currentfield.width;
                            }
                            if (this.currentfield.selfHostedHeight == '') {
                                this.currentfield.selfHostedHeight = Math.round((this.currentfield.originalHeight * this.currentfield.width) / this.currentfield.originalWidth);
                            }
                        }
                    } else if (mode == 'spacer' && this.currentfield.type == "spacer") {
                        this.currentfield.selfHostedUrl = this.getImageUrl() + '/img/spacer.gif';
                    } else if (mode == 'button' && this.currentfield.type == "button") {
                        if (this.currentfield.selfHostedWidth == '') {
                            this.currentfield.selfHostedWidth = this.currentfield.width;
                        }
                        if (this.currentfield.selfHostedHeight == '') {
                            this.currentfield.selfHostedHeight = this.currentfield.height;
                        }
                        if (this.currentfield.selfHostedUrl == '') {
                            var bgColor = '666666';
                            if (this.currentfield.backgroundColorType === 'default') {
                                bgColor = this.currentfield.defaultBackground;
                            } if (this.currentfield.backgroundColorType == 'black') {
                                bgColor = '#000000';
                            } else if (this.currentfield.backgroundColorType == 'gray') {
                                bgColor = '#666666';
                            } else if (this.currentfield.backgroundColorType == 'linkcolor') {
                                bgColor = this.signature.settings.linkColor;
                            } else if (this.currentfield.backgroundColorType == 'other' && this.currentfield.backgroundColor && this.currentfield.backgroundColor !== '') {
                                bgColor = this.currentfield.backgroundColor;
                            }
                            bgColor = bgColor.replace("#", "");
                            this.currentfield.selfHostedUrl = this.getImageUrl('icon') + '/button/' + this.currentfield.chosen + '-' + this.currentfield.chosenSize + '-' + bgColor + '-dark-' + this.currentfield.edges + '.png';
                        }
                    } else if (mode == 'newbutton' && this.currentfield.type == "newbutton") {
                        if (this.currentfield.selfHostedWidth == '') {
                            this.currentfield.selfHostedWidth = this.currentfield.width;
                        }
                        if (this.currentfield.selfHostedHeight == '') {
                            this.currentfield.selfHostedHeight = this.currentfield.height;
                        }
                        if (this.currentfield.selfHostedUrl == '') {
                            var bgColor = '666666';
                            if (this.currentfield.backgroundColorType === 'default') {
                                bgColor = this.currentfield.defaultBackground;
                            } if (this.currentfield.backgroundColorType == 'black') {
                                bgColor = '#000000';
                            } else if (this.currentfield.backgroundColorType == 'gray') {
                                bgColor = '#666666';
                            } else if (this.currentfield.backgroundColorType == 'linkcolor') {
                                bgColor = this.signature.settings.linkColor;
                            } else if (this.currentfield.backgroundColorType == 'other' && this.currentfield.backgroundColor && this.currentfield.backgroundColor !== '') {
                                bgColor = this.currentfield.backgroundColor;
                            }
                            bgColor = bgColor.replace("#", "");
                            var textColor = 'FFFFFF';
                            var iconColor = 'FFFFFF';
                            if (this.currentfield.iconTextColorType === 'white') {
                                textColor = 'FFFFFF';
                                iconColor = 'FFFFFF';
                            } if (this.currentfield.iconTextColorType == 'gray') {
                                textColor = '666666';
                                iconColor = '666666';
                            } else if (this.currentfield.iconTextColorType == 'darkgray') {
                                textColor = '333333';
                                iconColor = '333333';
                            } else if (this.currentfield.iconTextColorType == 'linkcolor') {
                                textColor = this.signature.settings.linkColor;
                                iconColor = this.signature.settings.linkColor;
                            } else if (this.currentfield.iconTextColorType == 'other') {
                                if (this.currentfield.textColor && this.currentfield.textColor !== '') {
                                    textColor = this.currentfield.textColor;
                                }
                                if (this.currentfield.iconColor && this.currentfield.iconColor !== '') {
                                    iconColor = this.currentfield.iconColor;
                                }
                            }
                            textColor = textColor.replace("#", "");
                            iconColor = iconColor.replace("#", "");
                            this.currentfield.selfHostedUrl = this.getImageUrl('icon') + '/buttons/' + this.currentfield.chosen + '-' + this.currentfield.chosenSize + '-' + bgColor + '-' + iconColor + '-' + textColor + '-' + this.currentfield.edges + '-' + this.currentfield.side + '.png';
                        }
                    } else if (mode == 'social' && this.currentfield.type == "social") {
                        var size = null;
                        if (this.signature.settings.socialIconSize == 'small') {
                            size = '22';
                        } else if (this.signature.settings.socialIconSize == 'large') {
                            size = '42';
                        } else {
                            size = '32';
                        }
                        if (this.currentfield.selfHostedWidth == '') {
                            this.currentfield.selfHostedWidth = size;
                        }
                        if (this.currentfield.selfHostedHeight == '') {
                            this.currentfield.selfHostedHeight = size;
                        }
                        if (this.currentfield.selfHostedUrl == '') {
                            if (this.signature.settings.socialIconSize == 'small') {
                                size = '22';
                            } else if (this.signature.settings.socialIconSize == 'large') {
                                size = '42';
                            } else {
                                size = '32';
                            }
                            var bgColor = this.getSocialColor(this.currentfield, 'background');
                            bgColor = bgColor.replace("#", "");
                            var iconColor = this.getSocialColor(this.currentfield, 'icon');
                            iconColor = iconColor.replace("#", "");
                            this.currentfield.selfHostedUrl = this.getImageUrl('icon') + '/social/' + this.currentfield.slug + '-' + this.signature.settings.socialIconShape + '-' + this.signature.settings.socialIconSize + '-' + bgColor + '-' + iconColor + '.png';
                        }
                    } else if (mode == 'icon' && this.currentfield.type == "icon") {
                        if (this.currentfield.selfHostedWidth == '') {
                            if (this.currentfield.iconOrigWidth > this.currentfield.iconOrigHeight) {
                                this.currentfield.selfHostedWidth = this.currentfield.iconSize;
                            } else {
                                this.currentfield.selfHostedWidth = Math.ceil((this.currentfield.iconSize * this.currentfield.iconOrigWidth) / this.currentfield.iconOrigHeight);
                            }
                            //this.currentfield.selfHostedWidth = this.currentfield.width;
                        }
                        if (this.currentfield.selfHostedHeight == '') {
                            if (this.currentfield.iconOrigWidth > this.currentfield.iconOrigHeight) {
                                this.currentfield.selfHostedHeight = Math.ceil((this.currentfield.iconSize * this.currentfield.iconOrigHeight) / this.currentfield.iconOrigWidth);
                            } else {
                                this.currentfield.selfHostedHeight = this.currentfield.iconSize;
                            }
                            //this.currentfield.selfHostedHeight = this.currentfield.height;
                        }
                        if (this.currentfield.selfHostedUrl == '') {
                            var iconColor = this.getIconColor(this.currentfield.iconColorType, this.currentfield.iconColor);
                            iconColor = iconColor.replace("#", "");
                            if (!iconColor) {
                                iconColor = '666666';
                            }
                            var icon = null;
                            var set = null;
                            var style = null;
                            if (!this.currentfield.icon) {
                                icon = 'paperplane';
                                set = 'fa';
                                style = 'solid';
                            } else {
                                icon = this.currentfield.icon;
                                set = this.currentfield.iconSet;
                                style = this.currentfield.iconStyle;
                            }
                            this.currentfield.selfHostedUrl = this.getImageUrl('icon') + '/icon/' + set + '-' + style + '-' + this.currentfield.iconSize + '-' + icon + '-' + iconColor + '.png';
                        }
                    }
                }
                if (mode == 'beforeicon' && this.currentfield.hasOwnProperty('beforeIconSelfHosted') && this.currentfield.beforeIconSelfHosted) {
                    // $fieldsettings->beforeIconSelfHosted = false;
                    // $fieldsettings->afterIconSelfHosted = false;
                    // $fieldsettings->beforeIconSelfHostedWidth = "";
                    // $fieldsettings->beforeIconSelfHostedHeight = "";
                    // $fieldsettings->afterIconSelfHostedWidth = "";
                    // $fieldsettings->afterIconSelfHostedHeight = "";
                    // $fieldsettings->beforeIconSelfHostedUrl = "";
                    // $fieldsettings->afterIconSelfHostedUrl = "";


                    // var iconColor = this.getIconColor(field.beforeIconColorType, field.beforeColor);
                    // iconColor = iconColor.replace("#", "");
                    // if (!iconColor) {
                    //     iconColor = '666666';
                    // }
                    // var iconWidth = null;
                    // var iconHeight = null;
                    // if (field.beforeIconOrigWidth > field.beforeIconOrigHeight) {
                    //     iconWidth = field.beforeIconSize;
                    //     iconHeight = Math.ceil((field.beforeIconSize * field.beforeIconOrigHeight) / field.beforeIconOrigWidth);
                    // } else {
                    //     iconHeight = field.beforeIconSize;
                    //     iconWidth = Math.ceil((field.beforeIconSize * field.beforeIconOrigWidth) / field.beforeIconOrigHeight);
                    // }
                    // value = value + '<img src="https://icon.signature.email/icon/' + field.beforeIconSet + '-' + field.beforeIconStyle + '-' + field.beforeIconSize + '-' + field.beforeIcon + '-' + iconColor + '.png" width="' + iconWidth + '" height="' + iconHeight + '" hspace="4" style="margin-right:4px;border:0px;vertical-align:middle;" border="0" nosend="1" alt="" />&nbsp;';


                    if (this.currentfield.beforeIconSelfHostedWidth == '') {
                        if (this.currentfield.beforeIconOrigWidth > this.currentfield.beforeIconOrigHeight) {
                            this.currentfield.beforeIconSelfHostedWidth = this.currentfield.beforeIconSize;
                        } else {
                            this.currentfield.beforeIconSelfHostedWidth = Math.ceil((this.currentfield.beforeIconSize * this.currentfield.beforeIconOrigWidth) / this.currentfield.beforeIconOrigHeight);
                        }
                    }
                    if (this.currentfield.beforeIconSelfHostedHeight == '') {
                        if (this.currentfield.beforeIconOrigWidth > this.currentfield.beforeIconOrigHeight) {
                            this.currentfield.beforeIconSelfHostedHeight = Math.ceil((this.currentfield.beforeIconSize * this.currentfield.beforeIconOrigHeight) / this.currentfield.beforeIconOrigWidth);
                        } else {
                            this.currentfield.beforeIconSelfHostedHeight = this.currentfield.beforeIconSize;
                        }
                    }
                    if (this.currentfield.beforeIconSelfHostedUrl == '') {
                        var iconColor = this.getIconColor(this.currentfield.beforeIconColorType, this.currentfield.beforeColor);
                        iconColor = iconColor.replace("#", "");
                        if (!iconColor) {
                            iconColor = '666666';
                        }
                        var icon = null;
                        var set = null;
                        var style = null;
                        if (!this.currentfield.beforeIcon) {
                            icon = 'paperplane';
                            set = 'fa';
                            style = 'solid';
                        } else {
                            icon = this.currentfield.beforeIcon;
                            set = this.currentfield.beforeIconSet;
                            style = this.currentfield.beforeIconStyle;
                        }
                        this.currentfield.beforeIconSelfHostedUrl = this.getImageUrl('icon') + '/icon/' + set + '-' + style + '-' + this.currentfield.beforeIconSize + '-' + icon + '-' + iconColor + '.png';
                    }
                }
                if (mode == 'aftericon' && this.currentfield.hasOwnProperty('afterIconSelfHosted') && this.currentfield.afterIconSelfHosted) {
                    if (this.currentfield. afterIconSelfHostedWidth == '') {
                        if (this.currentfield.afterIconOrigWidth > this.currentfield.afterIconOrigHeight) {
                            this.currentfield. afterIconSelfHostedWidth = this.currentfield.afterIconSize;
                        } else {
                            this.currentfield. afterIconSelfHostedWidth = Math.ceil((this.currentfield.afterIconSize * this.currentfield.afterIconOrigWidth) / this.currentfield.afterIconOrigHeight);
                        }
                    }
                    if (this.currentfield.afterIconSelfHostedHeight == '') {
                        if (this.currentfield.afterIconOrigWidth > this.currentfield.afterIconOrigHeight) {
                            this.currentfield.afterIconSelfHostedHeight = Math.ceil((this.currentfield.afterIconSize * this.currentfield.afterIconOrigHeight) / this.currentfield.afterIconOrigWidth);
                        } else {
                            this.currentfield.afterIconSelfHostedHeight = this.currentfield.afterIconSize;
                        }
                    }
                    if (this.currentfield.afterIconSelfHostedUrl == '') {
                        var iconColor = this.getIconColor(this.currentfield.afterIconColorType, this.currentfield.beforeColor);
                        iconColor = iconColor.replace("#", "");
                        if (!iconColor) {
                            iconColor = '666666';
                        }
                        var icon = null;
                        var set = null;
                        var style = null;
                        if (!this.currentfield.afterIcon) {
                            icon = 'paperplane';
                            set = 'fa';
                            style = 'solid';
                        } else {
                            icon = this.currentfield.afterIcon;
                            set = this.currentfield.afterIconSet;
                            style = this.currentfield.afterIconStyle;
                        }
                        this.currentfield.afterIconSelfHostedUrl = this.getImageUrl('icon') + '/icon/' + set + '-' + style + '-' + this.currentfield.afterIconSize + '-' + icon + '-' + iconColor + '.png';
                    }
                }
            },
            toggleSelfHostingImageChoices: function(choice) {
                if (choice.selfHosted === true) {
                    if (choice.url && choice.selfHostedUrl == '') {
                        choice.selfHostedUrl = this.getImageUrl('image') + "/" + choice.url;
                    }
                    if (choice.width && choice.originalWidth && choice.originalHeight) {
                        if (choice.selfHostedWidth == '') {
                            choice.selfHostedWidth = choice.width;
                        }
                        if (choice.selfHostedHeight == '') {
                            choice.selfHostedHeight = Math.round((choice.originalHeight * choice.width) / choice.originalWidth);
                        }
                    }
                }
            },
            onResizeSignature: function(width) {
                // var newWidth = width;
                // if (this.signature.settings.paddingLeft) {
                //     newWidth = newWidth - this.signature.settings.paddingLeft;
                // }
                // if (this.signature.settings.paddingRight) {
                //     newWidth = newWidth - this.signature.settings.paddingRight;
                // }
                // this.signature.settings.width = newWidth;
                this.signature.settings.width = width;
            },
            columnAutoWidth: function(column, withPx = false) {
                if (column.width) {
                    var newWidth = column.width;
                    if (!column.width || column.width < 10) {
                        newWidth = 10;
                    }
                    if (column.borderRight && column.borderRight > 0) {
                        newWidth = newWidth - column.borderRight;
                    }
                    if (column.borderLeft && column.borderLeft > 0) {
                        newWidth = newWidth - column.borderLeft;
                    }
                    if (withPx) {
                        return newWidth + 'px';
                    } else {
                        return newWidth;
                    }
                } else {
                    if (withPx) {
                        return '100%';
                    } else {
                        return 'auto';
                    }
                }
            },
            boxAutoWidth: function(box, withPx = false) {
                if (box.width) {
                    var newWidth = box.width;
                    if (!box.width || box.width < 10) {
                        newWidth = 10;
                    }
                    if (box.borderRight && box.borderRight > 0) {
                        newWidth = newWidth - box.borderRight;
                    }
                    if (box.borderLeft && box.borderLeft > 0) {
                        newWidth = newWidth - box.borderLeft;
                    }
                    if (withPx) {
                        return newWidth + 'px';
                    } else {
                        return newWidth;
                    }
                } else {
                    if (withPx) {
                        return '100%';
                    } else {
                        return 'auto';
                    }
                }
            },
            onResizeColumn: function(column, line, width) {
                //column.width = width;
                var newWidth = width;
                if (column.borderLeft && column.borderLeft > 0) {
                    newWidth = newWidth + column.borderLeft;
                }
                if (column.borderRight && column.borderRight > 0) {
                    newWidth = newWidth + column.borderRight;
                }
                column.width = newWidth;
                
                var fullTableWidth = 0;
                line.columns.forEach(function ( column ) {
                    var colWidth = column.width;
                    // if (column.paddingLeft && column.paddingLeft > 0) {
                    //     colWidth = colWidth + column.paddingLeft;
                    // }
                    // if (column.paddingRight && column.paddingRight > 0) {
                    //     colWidth = colWidth + column.paddingRight;
                    // }
                    if (!column.width) {
                        colWidth = 100;
                    }
                    fullTableWidth = fullTableWidth + colWidth;
                }, fullTableWidth);
                line.width = fullTableWidth;
                if (fullTableWidth > this.signature.settings.width) {
                    if (fullTableWidth <= 600) {
                        this.signature.settings.width = fullTableWidth;
                    } else {
                        this.signature.settings.width = 600;
                    }
                }
            },
            onResizeBox: function(box, width) {
                //column.width = width;
                var newWidth = width;
                if (box.borderLeft && box.borderLeft > 0) {
                    newWidth = newWidth + box.borderLeft;
                }
                if (box.borderRight && box.borderRight > 0) {
                    newWidth = newWidth + box.borderRight;
                }
                box.width = newWidth;
            },
            addFieldAvailable: function(line, width = null) {
                if (line.fields.length == 1) {
                    if (line.fields[0].type === 'textarea') {
                        return false;
                    } else if (line.fields[0].type === 'image') {
                        var imageWidth = line.fields[0].width;
                        var widthAndButton = width - 20;
                        if (widthAndButton <= imageWidth) {
                            return false;
                        } else {
                            return true;
                        }
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            },
            sendSignatureNow: function() {
                var self = this;
                self.sendEmailError = null;
                var theemail = null;
                if (this.hasEditableRequiredEmail) {
                    theemail = this.checkForEditableRequiredEmail('fieldvalue');
                } else {
                    theemail = this.statsEmail;
                }
                if (this.signatureid && this.purchased) {
                    axios.post('/generator/send-signature', { id: this.signatureid, signature: this.signature, email: theemail, destination: this.sendSignatureEmail, reply: this.sendSignatureEmailReply, edit: this.sendSignatureEmailEdit } )
                    .then(function (response) {
                        if (response.data.status == 'success') {
                            self.showSendEmailModal = false;
                            self.signatureDistributionMode = 'email';
                            self.signatureCopiedModal = true;
                            // Vue.notify({
                            //     group: 'bottomleftmessages',
                            //     title: 'Signature sent via email!',
                            //     type: 'success',
                            // });
                        } else if (response.data.status == 'error') {
                            self.sendEmailError = response.data.message;
                        } else {
                            self.sendEmailError = 'Sorry, there was a problem sending the email';
                        }
                    })
                    .catch(function (error) {
                        self.sendEmailError = 'Sorry, there was a problem sending the email';
                    });
                } else {
                    if (!self.signatureid) {
                        self.sendEmailError = "Please save your signature first."
                    } else {
                        self.sendEmailError = "Paid account required."
                    }
                }
            },
            checkSignatureSlug: function() {
                clearTimeout(this.signature_slug_timeout);
                this.signature_slug_timeout = setTimeout(() => {
                    var self = this;
                    self.signature_slug = self.signature_slug.replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
                    if (self.signature_slug) {
                        axios.post('/generator/check-slug', { signature_slug: this.signature_slug, signature_id: this.signatureid } )
                        .then(function (response) {
                            if (response.data.available == true) {
                                self.signature_slug_available = true;
                            } else {
                                self.signature_slug_available = false;
                            }
                        })
                        .catch(function (error) {
                            
                        });
                    }
                }, 500);
            },
            createAccountAndSave: function() {
                var self = this;
                // self.signature.fields.forEach(function (field, key) {
                //     if (field.valueType == "userfillable") {
                //         field.value = '';
                //     }
                // });
                // this.fieldKeys.forEach(function (key) {
                //     if (this.signature.fields[key].valueType == "userfillable") {
                //         this.signature.fields[key].value = '';
                //     }
                // }, this);
                // this.signature.lines.forEach(function ( line ) {
                //     line.fields.forEach(function ( thefield ) {
                //         if (thefield.valueType == "userfillable") {
                //             thefield.value = '';
                //         }
                //     }, this);
                // }, this);
                //this.clearUserFillableFields(); 
                this.createAccountAndSaveErrors = null;
                var object_to_send = {email: self.accountEmail, password: self.accountPassword, password_confirmation: self.accountPasswordConfirm, email_consent: self.accountEmailConsent, signature_name: self.signature_name, signature_title: self.signature_title, signature: self.signature, single_signature: self.single_signature};
                axios.post('/generator/create-account', null, { data: object_to_send } )
                .then(function (response) {
                    if (response.data.status && response.data.status == 'success') {
                        self.showCreateAccountModal = false;
                        //self.showPricingModal = true;
                        self.signatureid = response.data.signatureid;
                        self.user_id = response.data.user_id;
                        self.organization_id = response.data.organization_id;
                        self.sendSignatureEmail = self.accountEmail;
                        self.recentlySaved = true;
                        self.startPurchase('freshaccount');
                        $crisp.push(["set", "user:email", [self.accountEmail]]);
                        $crisp.push(["set", "session:data", [[["user_id", self.user_id], ["org_id", self.organization_id]]]]);
                        if (typeof gtag != "undefined") {
                            gtag('event', 'conversion', {
                                'send_to': 'AW-1035274589/n5lZCOqF_qsBEN2S1O0D',
                            });
                        }
                    } else {
                        console.log(response);
                    }
                })
                .catch(function (error) {
                    // console.log(error);
                    // console.log(error.response);
                    if (error.response.data.errors) {
                        self.createAccountAndSaveErrors = error.response.data.errors;
                    } else {
                        console.log(error);
                        console.log(error.response);
                    }
                });
            },
            sendViaEmail() {
                if (this.user_id && this.organization_id) {
                    this.saveTemplate(false);
                }
                if (this.single_signature === false) {
                    this.checkIfValidToCopy();
                    if (this.validToCopy) {
                        var destination;
                        if (this.hasEditableRequiredEmail) {
                            destination = this.checkForEditableRequiredEmail('fieldvalue');
                        } else {
                            destination = this.statsEmail;
                        }
                        this.sendSignatureEmail = destination;
                        this.showSendEmailModal = true;
                    }
                } else {
                    this.showSendEmailModal = true;
                }
            },
            startPurchase: function(status, allowAccountMessage = true) {
                // console.log("start purchse");
                // console.log(this.$refs);
                //this.showPricingModal = false;
                if (status) {
                    this.purchaseMode = status;
                } else {
                    this.purchaseMode = null;
                }
                if (allowAccountMessage) {
                    this.signatureSaveModal = true;
                } else {
                    Vue.notify({
                        group: 'bottomleftmessages',
                        title: 'Signature Saved!',
                        type: 'success',
                    });
                }
                //this.chosenPlan = plan_size;
            },
            openPurchaseModal() {
                this.showPurchaseModal = true;
                this.signatureSaveModal = false;
            },
            saveTemplate: function(allowAccountMessage = true) {
                //this.clearInvalidFields();
                var signatureToSave = null;
                if (this.previewActive) {
                    signatureToSave = this.signatureBackup;
                } else {
                    signatureToSave = this.signature;
                }
                this.validToCopy = true;
                if (this.user_id && this.organization_id) {
                    var self = this;
                    //this.clearUserFillableFields();
                    if (self.signature_slug_available === false) {
                        self.signature_slug = null;
                        self.signature_slug_available = null;
                    }
                    if (self.signatureid) {
                        axios.post('/generator/save/' + self.signatureid, {signature: signatureToSave, signature_name: self.signature_name, signature_title: self.signature_title, signature_slug: self.signature_slug,signature_access_code: self.signature_access_code, published: self.published, single_signature: self.single_signature})
                        .then(function (response) {
                            if (response.data.status === 'success') {
                                //alert("Signature Saved");
                                self.recentlySaved = true;
                                self.starting_signature_slug = self.signature_slug;
                                if (self.purchased) {
                                    Vue.notify({
                                        group: 'bottomleftmessages',
                                        title: 'Signature Saved!',
                                        type: 'success',
                                    });
                                    if (typeof gtag != "undefined") {
                                        gtag('event', 'savesignature', {
                                            'event_category': 'Designer',
                                            'event_label': 'Save Purchased Account'
                                        });
                                    }
                                } else {
                                    if (typeof gtag != "undefined") {
                                        gtag('event', 'savesignature', {
                                            'event_category': 'Designer',
                                            'event_label': 'Save Unpurchased Account'
                                        });
                                    }
                                    self.startPurchase('signaturesaved', allowAccountMessage);
                                }
                            }
                        })
                        .catch(function (error) {
                            //console.log(error);
                            if (error.response && error.response.status && error.response.status == 419) {
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: 'The page has expired, please reload.',
                                    type: 'error',
                                });
                            } else {
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: 'There was an issue saving.',
                                    type: 'error',
                                });
                            }
                        });
                    } else {
                        //When is this ever used?
                        axios.post('/generator/save', {signature: signatureToSave, signature_name: self.signature_name, signature_title: self.signature_title, signature_slug: self.signature_slug, signature_access_code: self.signature_access_code, single_signature: self.single_signature})
                        .then(function (response) {
                            // console.log(response);
                            if (response.data.status === 'success') {
                                self.signatureid = response.data.signatureid;
                                //alert("Signature Saved");
                                self.recentlySaved = true;
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: 'Signature Saved!',
                                    type: 'success',
                                });
                            } else if (response.data.status === 'error') {
                                if (response.data.error_type == 'signature_limit') {
                                    self.timeToUpgradeModal = true;
                                }
                            }
                        })
                        .catch(function (error) {
                            if (error.response && error.response.status && error.response.status == 419) {
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: 'The page has expired, please reload.',
                                    type: 'error',
                                });
                            } else {
                                Vue.notify({
                                    group: 'bottomleftmessages',
                                    title: 'There was an issue saving.',
                                    type: 'error',
                                });
                            }
                        });
                    }
                } else {
                    this.showCreateAccountModal = true;
                    if (typeof gtag != "undefined") {
                        gtag('event', 'savesignature', {
                            'event_category': 'Designer',
                            'event_label': 'Save No Account'
                        });
                        gtag('event', 'conversion', {
                            'send_to': 'AW-1035274589/n5lZCOqF_qsBEN2S1O0D',
                        });
                    }
                }
            }
        }
    }
</script>
